{
  "navigation.customers": "Customers",
  "navigation.contacts": "Contacts",
  "navigation.projects": "Projects",
  "navigation.subscriptions": "Subscriptions",
  "navigation.settlements": "Settlements",
  "navigation.invoices": "Invoices",
  "navigation.configuration": "Configuration",
  "navigation.marketing": "Marketing",
  "navigation.analysis": "Analytics",
  "breadcrumb.analysis": "Analytics",
  "view.analysis.headline": "Analytics",
  "tab.analysis.income": "Revenue",
  "tab.analysis.expenses": "Expenses",
  "view.analysisExpenseOverview.col.category": "Category",
  "view.analysisExpenseOverview.col.total": "Total",
  "view.analysisExpenseOverview.total": "Total",
  "view.analysisExpenseOverview.unassigned": "Unassigned",
  "view.analysisExpenseOverview.empty": "There are no expenses in this period.",
  "view.analysisExpenseOverview.legend.provisional": "Provisional: the month is not complete yet, or the amount is based on a proposed service period.",
  "view.analysisExpenseOverview.legend.provisionalShort": "Provisional",
  "view.analysisExpenseOverview.legend.drillDown": "Click an amount to see its invoices.",
  "view.analysisExpenseOverview.notIncluded": "Salaries, social security contributions and taxes are not included. All amounts are net, by month of service.",
  "component.periodTable.expand": "Expand",
  "component.periodTable.collapse": "Collapse",
  "component.analysis.range": "{from} – {to}",
  "component.analysis.previousMonth": "One month back",
  "component.analysis.nextMonth": "One month forward",
  "component.analysis.kpi.change": "Change vs. previous month",
  "component.analysis.kpi.change.sub": "{percent} vs. previous month",
  "component.analysis.kpi.average": "Average of the months",
  "component.analysis.kpi.average.sub": "{count, plural, one {# completed month} other {# completed months}}",
  "component.analysis.ranking.new": "new",
  "component.analysis.ranking.showAll": "Show all {count}",
  "component.analysis.ranking.showLess": "Show fewer",
  "component.periodTable.changeToPrevious": "Change to the previous period",
  "view.analysisExpenseOverview.kpi.total": "Expenses",
  "view.analysisExpenseOverview.kpi.toConfirm": "To confirm",
  "view.analysisExpenseOverview.kpi.toConfirm.sub": "Invoices with a proposed service period",
  "view.analysisExpenseOverview.ranking": "Expenses by supplier",
  "view.analysisExpenseOverview.ranking.empty": "There are no expenses in this period.",
  "view.analysisExpenseOverview.ranking.gone": "no invoice",
  "view.analysisIncome.kpi.total": "Revenue",
  "view.analysisIncome.kpi.perCustomer": "Average per customer",
  "view.analysisIncome.kpi.perCustomer.sub": "{customers, plural, one {# customer} other {# customers}}, {subscriptions, plural, one {# billed subscription} other {# billed subscriptions}}",
  "view.analysisIncome.col.group": "Group",
  "view.analysisIncome.col.total": "Total",
  "view.analysisIncome.total": "Total",
  "view.analysisIncome.ranking": "Revenue by customer",
  "view.analysisIncome.ranking.gone": "lost",
  "view.analysisIncome.ranking.topThree": "The three largest customers make up {percent} of the revenue.",
  "view.analysisIncome.ranking.newAndGone": "{newCount, plural, =0 {No new customers} one {# new customer} other {# new customers}}, {goneCount, plural, =0 {no lost customers} one {# lost customer} other {# lost customers}}",
  "view.analysisIncome.legend.provisional": "Provisional: the month has not ended yet, settlements are still missing.",
  "view.analysisIncome.legend.expand": "The arrow in front of a group shows its cost categories.",
  "view.analysisIncome.notice": "All amounts are net. Revenue counts in the month of the cut-off date of the settlement, which is always the end of a month. For subscriptions this is in general the month of service. Only a few back-billings for earlier months count in the month they were billed.",
  "revenue.group.CLUSTERS": "Clusters",
  "revenue.group.INSTANCES_AND_PROJECTS": "Instances & projects",
  "revenue.group.DATABASES": "Databases",
  "revenue.group.STORAGE_AND_TRAFFIC": "Storage & traffic",
  "revenue.group.SERVICES": "Services",
  "revenue.group.OTHER": "Other",
  "revenue.costCategory.uncategorized": "No category",
  "view.suppliers.summary": "{total, plural, one {# supplier} other {# suppliers}}, {unassigned} of them without expense category",
  "view.suppliers.search": "Search supplier or spelling",
  "view.suppliers.empty": "No suppliers yet. They are created when the incoming invoices are imported from FastBill.",
  "view.suppliers.col.name": "Supplier",
  "view.suppliers.col.expenseCategory": "Expense category",
  "view.suppliers.col.billingCycle": "Billing cycle",
  "view.suppliers.col.netAmount": "Net {start} – {end}",
  "view.suppliers.col.invoiceCount": "Invoices",
  "view.suppliers.col.servicePeriods": "Service periods",
  "view.suppliers.proposals": "{count, plural, one {# proposal} other {# proposals}}",
  "view.suppliers.proposals.title": "Review and confirm proposed service periods",
  "view.suppliers.unassigned": "Not assigned",
  "view.suppliers.noBillingCycle": "– no billing cycle",
  "view.suppliers.action.configure": "Configure supplier",
  "view.suppliers.action.merge": "Merge into another supplier",
  "view.suppliers.action.separate": "Separate as a supplier of its own",
  "expense.category.INFRASTRUCTURE": "Infrastructure",
  "expense.category.SERVICES_AND_LICENSES": "Services & licenses",
  "expense.category.HARDWARE_AND_EQUIPMENT": "Hardware & equipment",
  "expense.category.VEHICLES": "Vehicles",
  "expense.category.TRAVEL": "Travel",
  "expense.category.INSURANCE": "Insurance",
  "expense.category.CONSULTING_AND_ADMINISTRATION": "Consulting & administration",
  "expense.category.MEMBERSHIPS_AND_DONATIONS": "Memberships & donations",
  "expense.category.OTHER": "Other",
  "expense.billingCycle.MONTHLY_IN_ARREARS": "monthly in arrears",
  "expense.billingCycle.MONTHLY_IN_ADVANCE": "monthly in advance",
  "expense.billingCycle.QUARTERLY_IN_ADVANCE": "quarterly in advance",
  "expense.billingCycle.YEARLY_IN_ADVANCE": "yearly in advance",
  "expense.billingCycle.ONE_TIME": "one-time",
  "expense.amountEstimateSource.HETZNER": "Hetzner cost estimate",
  "view.incomingInvoices.filter.supplier": "Supplier",
  "view.incomingInvoices.filter.allSuppliers": "All suppliers",
  "view.incomingInvoices.filter.category": "Expense category",
  "view.incomingInvoices.filter.allCategories": "All categories",
  "view.incomingInvoices.filter.month": "Month of service",
  "view.incomingInvoices.filter.status": "Status of the service period",
  "view.incomingInvoices.filter.allStatuses": "All service periods",
  "view.incomingInvoices.filter.search": "Invoice no., supplier or amount",
  "view.incomingInvoices.filter.deleted": "Show deleted",
  "view.incomingInvoices.filter.reset": "Reset filter",
  "view.incomingInvoices.summary": "{count, plural, one {# invoice} other {# invoices}}",
  "view.incomingInvoices.empty": "No invoices match this filter.",
  "view.incomingInvoices.col.supplier": "Supplier",
  "view.incomingInvoices.col.invoiceNumber": "Invoice number",
  "view.incomingInvoices.col.invoiceDate": "Invoice date",
  "view.incomingInvoices.col.servicePeriod": "Service period",
  "view.incomingInvoices.action.confirmAll": "Confirm all {count}",
  "view.incomingInvoices.col.expenseCategory": "Expense category",
  "view.incomingInvoices.filter.monthPlaceholder": "YYYY-MM",
  "view.incomingInvoices.filter.monthHint": "Shows invoices whose service period touches this month",
  "view.incomingInvoices.serviceMonthHint": "All invoices whose service period touches the month are shown. For longer periods, only the share of the month counts.",
  "view.incomingInvoices.serviceMonthTotal": "Total of the shares in the month: {amount}",
  "view.incomingInvoices.col.shareInMonth": "Share in month (EUR)",
  "view.incomingInvoices.col.netAmount": "Net (EUR)",
  "view.incomingInvoices.col.paidDate": "Paid on",
  "view.incomingInvoices.hasDocument": "PDF archived",
  "view.incomingInvoices.action.show": "Show invoice",
  "expense.servicePeriodStatus.PROPOSED": "proposed",
  "expense.servicePeriodStatus.CONFIRMED": "confirmed",
  "expense.servicePeriodSource.FASTBILL": "Taken over from FastBill",
  "expense.servicePeriodSource.BILLING_CYCLE": "Proposed from the supplier's billing cycle",
  "expense.servicePeriodSource.MANUAL": "Set by hand",
  "expense.servicePeriod.invoiceMonth": "Invoice month",
  "expense.category.overridden": "overridden",
  "expense.category.overridden.title": "Differs from the supplier's category for this invoice",
  "view.incomingInvoice.back": "Invoices",
  "view.incomingInvoice.details": "Invoice data",
  "view.incomingInvoice.supplier": "Supplier",
  "view.incomingInvoice.dueDate": "Due on",
  "view.incomingInvoice.netAmountInEuro": "Net (EUR)",
  "view.incomingInvoice.netAmount": "Net",
  "view.incomingInvoice.vatAmount": "VAT",
  "view.incomingInvoice.grossAmount": "Gross",
  "view.incomingInvoice.exchangeRate": "Exchange rate",
  "view.incomingInvoice.exchangeRateValue": "1 EUR = {rate} {currency}",
  "view.incomingInvoice.fastBillInvoiceId": "FastBill ID",
  "view.incomingInvoice.deletedInFastBill": "Deleted in FastBill on {date}",
  "view.incomingInvoice.document.notArchived": "No PDF has been archived for this invoice yet.",
  "view.incomingInvoice.document.loading": "Loading the PDF …",
  "view.incomingInvoice.category.ofSupplier": "Category of the supplier",
  "view.incomingInvoice.category.ofSupplierWithCategory": "Category of the supplier ({category})",
  "view.incomingInvoice.category.ofSupplierHint": "The invoice counts towards the category of its supplier. Choosing another one applies to this invoice only.",
  "view.incomingInvoice.category.overriddenHint": "The category is overridden for this invoice. Choose “Category of the supplier” to reset it.",
  "view.incomingInvoice.servicePeriod.confirm": "Confirm",
  "view.incomingInvoice.servicePeriod.start": "From",
  "view.incomingInvoice.servicePeriod.end": "To (inclusive)",
  "view.incomingInvoice.servicePeriod.endBeforeStart": "The end cannot lie before the start.",
  "view.incomingInvoice.servicePeriod.correct": "Save and confirm period",
  "view.incomingInvoice.servicePeriod.set": "Set period",
  "view.incomingInvoice.servicePeriod.invoiceMonthHint": "Without a service period of its own, the invoice counts in the month of its invoice date.",
  "errors.failedToChangeExpenseInvoiceCategory": "Could not save the category of the invoice.",
  "errors.failedToConfirmServicePeriod": "Could not confirm the service period.",
  "errors.failedToCorrectServicePeriod": "Could not save the service period.",
  "errors.failedToAssignSupplierExpenseCategory": "Could not save the expense category.",
  "errors.failedToAssignSupplierBillingCycle": "Could not save the billing cycle.",
  "errors.failedToAssignSupplierAmountEstimateSource": "Could not save the source of the estimate.",
  "errors.failedToRenameSupplier": "Could not rename the supplier.",
  "errors.failedToConfirmSupplierServicePeriodProposals": "Could not confirm the proposed service periods.",
  "dialog.ConfirmSupplierServicePeriodProposalsDialog.headline": "Confirm service periods",
  "dialog.ConfirmSupplierServicePeriodProposalsDialog.submitLabel": "Confirm",
  "dialog.ConfirmSupplierServicePeriodProposalsDialog.confirmMessage": "Confirm {count, plural, one {the proposed service period} other {all # proposed service periods}} of {name}? Single invoices can still be corrected afterwards.",
  "errors.failedToMergeSupplier": "Could not merge the suppliers.",
  "errors.failedToSeparateSupplierSpelling": "Could not separate the spelling.",
  "dialog.ConfigureSupplierDialog.headline": "Configure supplier: {name}",
  "dialog.ConfigureSupplierDialog.amountEstimateSourceLabel": "Estimate amount from",
  "dialog.ConfigureSupplierDialog.noAmountEstimateSource": "Continue the last invoices",
  "dialog.ConfigureSupplierDialog.amountEstimateSourceHint": "The forecast takes the expected amounts of this supplier from the chosen estimate, as long as it is up to date. Otherwise it continues its last invoices.",
  "dialog.MergeSupplierDialog.headline": "Merge “{name}”",
  "dialog.MergeSupplierDialog.targetLabel": "Merge into",
  "dialog.MergeSupplierDialog.targetPlaceholder": "Choose supplier",
  "dialog.MergeSupplierDialog.description": "{count, plural, one {The spelling} other {All # spellings}} of “{name}”, and with them all invoices, move to the chosen supplier. “{name}” is removed afterwards, its expense category and billing cycle are lost.",
  "dialog.MergeSupplierDialog.submit": "Merge",
  "dialog.SeparateSupplierSpellingDialog.headline": "Separate spelling",
  "dialog.SeparateSupplierSpellingDialog.description": "“{spelling}” is separated from “{name}” and gets a supplier of its own, without expense category and billing cycle for now. The invoices with this spelling move along.",
  "dialog.SeparateSupplierSpellingDialog.submit": "Separate",
  "tab.analysis.simulation": "Price simulation",
  "tab.analysis.simulation.soon": "Coming soon",
  "view.analysisIncome.empty": "No billed revenue in this period.",
  "view.analysisIncome.filter.all": "All",
  "view.analysisIncome.filter.subscriptions": "Subscriptions",
  "view.analysisIncome.filter.projects": "Projects",
  "view.analysisIncome.filter.allServices": "All services",
  "view.analysisSimulation.basis": "Basis: {month}",
  "view.analysisSimulation.reset": "Reset",
  "view.analysisSimulation.run": "Simulate ({count})",
  "view.analysisSimulation.runEmpty": "Simulate",
  "view.analysisSimulation.runTitle": "Apply {count} changed plan(s)",
  "view.analysisSimulation.expired": "discontinued",
  "view.analysisSimulation.notBilled": "not billed in the base month",
  "view.analysisSimulation.editor": "Plan prices",
  "view.analysisSimulation.filter": "Filter plans…",
  "view.analysisSimulation.kpi.baseline": "Billed (baseline)",
  "view.analysisSimulation.kpi.simulated": "Simulated",
  "view.analysisSimulation.kpi.delta": "Difference",
  "view.analysisSimulation.computing": "calculating…",
  "view.analysisSimulation.scenarios": "Scenarios",
  "view.analysisSimulation.scenarios.namePlaceholder": "Scenario name…",
  "view.analysisSimulation.scenarios.save": "Save",
  "view.analysisSimulation.scenarios.saveTitle": "Save the current price changes as a scenario",
  "view.analysisSimulation.scenarios.overwrite": "Overwrite",
  "view.analysisSimulation.scenarios.overwriteTitle": "Overwrite scenario “{name}” with the current price changes",
  "view.analysisSimulation.scenarios.empty": "No scenarios saved yet.",
  "view.analysisSimulation.scenarios.overrideCount": "{count, plural, one {# change} other {# changes}}",
  "view.analysisSimulation.scenarios.load": "Load",
  "view.analysisSimulation.scenarios.delete": "Delete",
  "priceField.monthly": "Monthly",
  "priceField.hourly": "Hourly",
  "priceField.daily": "Daily",
  "priceField.monthlyCap": "Cap/month",
  "priceField.percentagePerProject": "%/project",
  "priceField.outboundNetworkTransferPerGigabyte": "Transfer/GB",
  "priceField.pricePerUnit": "Per unit",
  "planType.instance": "Instances",
  "planType.project": "Projects",
  "planType.cluster": "Clusters",
  "planType.clusterNode": "Cluster nodes",
  "planType.databaseServer": "Database servers",
  "planType.redisServer": "Redis servers",
  "planType.elasticsearchServer": "Elasticsearch servers",
  "planType.grafanaInstance": "Grafana instances",
  "planType.support": "Support",
  "planType.meteredResource": "Metered resources",
  "tab.analysis.serverCost": "Server costs",
  "tab.analysis.openItems": "Open items",
  "view.analysisServerCost.basis": "As of: {month} (latest invoice)",
  "view.analysisServerCost.reset": "Reset",
  "view.analysisServerCost.intro": "Actual Hetzner cluster costs from the latest invoice. Internal clusters (Core/control plane, test) are excluded from the customer figures and shown separately below. Enter a price change in % per server type (Hetzner increase or server-type switch) — the total shows the effect on the overall contribution margin. Cluster overhead (volumes, load balancers, traffic, IPs, RAM upgrades) is included but held constant in the simulation. Note: for Hetzner Cloud the \"avg/node\" is distorted by short-lived autoscaler nodes; the per-type total is reliable.",
  "view.analysisServerCost.kpi.current": "Server cost current",
  "view.analysisServerCost.kpi.simulated": "Server cost simulated",
  "view.analysisServerCost.kpi.deltaCost": "Δ cost/month",
  "view.analysisServerCost.kpi.deltaMargin": "Δ contribution margin",
  "view.analysisServerCost.byType": "Cost by server type",
  "view.analysisServerCost.empty": "No server data yet. Import Hetzner invoices first.",
  "view.analysisServerCost.role.cp": "Control plane",
  "view.analysisServerCost.role.wk": "Worker",
  "view.analysisServerCost.col.type": "Server type",
  "view.analysisServerCost.col.nodes": "Nodes",
  "view.analysisServerCost.col.perNode": "Avg/node",
  "view.analysisServerCost.col.total": "Current/month",
  "view.analysisServerCost.col.change": "Change",
  "view.analysisServerCost.col.newTotal": "New/month",
  "view.analysisServerCost.overhead": "Cluster overhead (volumes, LB, traffic, IPs, RAM upgrades)",
  "view.analysisServerCost.held": "held",
  "view.analysisServerCost.totalRow": "Customer clusters total",
  "view.analysisServerCost.internal": "Internal infrastructure (Core/control plane, test)",
  "view.analysisServerCost.notCustomer": "not customer-attributable",

  "view.analysisOpenItems.headline": "Open items as of {date}",
  "view.analysisOpenItems.intro": "The receivables as they stood at the cut-off date, not as they look today. An invoice which was open at the cut-off date and paid later on is listed here even though it reads as \"Paid\" by now. The \"State today\" column shows you the difference. Invoices voided or reversed after the cut-off date are included as well, because they were receivables on that date.",
  "view.analysisOpenItems.cutOffDateOption": "Cut-off date 31.12.{year, number, ::group-off}",
  "view.analysisOpenItems.limitToYear": "Only invoices dated {year, number, ::group-off}",
  "view.analysisOpenItems.kpi.count": "Open items",
  "view.analysisOpenItems.kpi.gross": "Total gross",
  "view.analysisOpenItems.kpi.gross.sub": "{amount} net",
  "view.analysisOpenItems.kpi.collectable": "Thereof collected or open",
  "view.analysisOpenItems.kpi.collectable.sub": "{count, plural, one {# invoice} other {# invoices}}",
  "view.analysisOpenItems.kpi.writtenOff": "Thereof written off later",
  "view.analysisOpenItems.kpi.writtenOff.sub": "{count, plural, one {# invoice} other {# invoices}}",
  "view.analysisOpenItems.tableHeadline": "Invoices",
  "view.analysisOpenItems.empty": "No invoice was open at this cut-off date.",
  "view.analysisOpenItems.reverseInvoice": "Reverse",
  "view.analysisOpenItems.col.invoiceNumber": "Number",
  "view.analysisOpenItems.col.invoiceDate": "Invoice date",
  "view.analysisOpenItems.col.dueDate": "Due",
  "view.analysisOpenItems.col.customer": "Customer",
  "view.analysisOpenItems.col.net": "Net",
  "view.analysisOpenItems.col.gross": "Gross",
  "view.analysisOpenItems.col.stateToday": "State today",
  "view.analysisOpenItems.col.settledAt": "Settled",
  "contact.notFound": "Contact not found",
  "contact.type.team": "Team Contact",
  "contact.type.individual": "Contact",
  "contact.salutation": "Salutation",
  "contact.salutation.mr": "Mr",
  "contact.salutation.mrs": "Mrs",
  "contact.salutation.mx": "Mx",
  "contact.salutation.hello": "Hello",
  "contact.givenName": "Given name",
  "contact.familyName": "Family name",
  "contact.emailAddress": "Email address",
  "contact.phoneNumber": "Phone number",
  "contact.teamName": "Team name",
  "contact.preferredLanguage": "Preferred language",
  "contact.dataOrigin.description.question": "Where was this contact data acquired from?",
  "contact.dataOrigin.collectedAt.question": "When was this data collected?",
  "contact.dataOrigin.note": "Notes on data origin",
  "contact.dataOrigin.note.placeholder": "e.g. the URL of the website where the data was taken from or the IP address of the visitor who submitted a contact form",
  "contact.dataOrigin.descriptions.selectDescription": "Select a description…",
  "contact.dataOrigin.descriptions.customDescription": "Custom description…",
  "contact.dataOrigin.descriptions.phoneCall": "Provided by person during phone call",
  "contact.dataOrigin.descriptions.onlineMeeting": "Provided by contact during online meeting",
  "contact.dataOrigin.descriptions.email": "Provided by person via email",
  "contact.dataOrigin.descriptions.socialMedia": "Provided by person via social media",
  "contact.dataOrigin.descriptions.formSubmission": "Provided by person via a form submission",
  "contact.dataOrigin.descriptions.inPersonMeeting": "Provided by contact during an in-person meeting",
  "contact.dataOrigin.descriptions.lookedUpInternet": "Looked up from public Internet sources",
  "contact.attributes": "Attributes",
  "contact.attributes.addAttribute": "Add attribute",
  "contact.attributes.noAttributes": "No attributes set",
  "contact.attributes.editAttribute": "Edit attribute",
  "contact.attributes.deleteAttribute": "Delete attribute",
  "contact.attributes.confirmDelete": "Are you sure you want to delete this attribute?",
  "contact.attributes.selectAttribute": "Select attribute...",
  "contact.customers": "Customers",
  "contact.customers.noCustomers": "Not assigned to any customer",
  "dialog.AddContactDialog.headline": "Add Contact",
  "dialog.AddContactDialog.submitLabel": "Add",
  "dialog.AddContactDialog.label": "Team or person contact",
  "dialog.AddContactDialog.searchForContact": "Search for a contact",
  "dialog.CreateContactDialog.createContactHeadline": "Create Contact",
  "dialog.CreateContactDialog.questionPersonOrTeam": "Is the new contact a real person or for a team or department?",
  "dialog.CreateContactDialog.person": "Person",
  "dialog.CreateContactDialog.team": "Team",
  "dialog.CreatePersonContactDialog.headline": "Create Contact",
  "dialog.CreateTeamContactDialog.headline": "Create Team Contact",
  "dialog.CreateTeamContactDialog.teamNamePlaceholder": "Backoffice Team",
  "dialog.CreateTeamContactDialog.emailPlaceholder": "backoffice@example.com",
  "dialog.CreateTeamContactDialog.phonePlaceholder": "+49 451 3050350",
  "dialog.UpdatePersonContactDialog.headline": "Update Contact",
  "dialog.UpdatePersonContactDialog.givenNamePlaceholder": "John",
  "dialog.UpdatePersonContactDialog.familyNamePlaceholder": "Doe",
  "dialog.UpdatePersonContactDialog.emailPlaceholder": "john.doe@example.com",
  "dialog.UpdatePersonContactDialog.phonePlaceholder": "+49 451 3050350",
  "dialog.UpdateTeamContactDialog.headline": "Update Team Contact",
  "dialog.UpdateTeamContactDialog.submitLabel": "Update",
  "dialog.SetContactPreferredLanguageDialog.headline": "Set Preferred Language",
  "dialog.SetContactPreferredLanguageDialog.noPreference": "No preference",
  "dialog.UpdateContactRolesDialog.headline": "Assign Contact Roles",
  "dialog.UpdateContactRolesDialog.submitLabel": "Assign roles",
  "dialog.UpdateContactRolesDialog.instruction": "Select the roles {contact} has in relation to {customer}.",
  "dialog.UpdateContactRolesDialog.hint": "{contact} may have access to sensitive information depending on the roles selected.",
  "dialog.UpdateContactRolesDialog.role.primaryContact.label": "Primary contact",
  "dialog.UpdateContactRolesDialog.role.primaryContact.description": "Contact for all topics not covered by other contacts.",
  "dialog.UpdateContactRolesDialog.role.security.label": "Security",
  "dialog.UpdateContactRolesDialog.role.security.description": "Contact for security and privacy issues and vulnerabilities.",
  "dialog.UpdateContactRolesDialog.role.technical.label": "Technical",
  "dialog.UpdateContactRolesDialog.role.technical.description": "Contact for technical events and issues, such as outages or bugs.",
  "dialog.UpdateContactRolesDialog.role.billing.label": "Billing",
  "dialog.UpdateContactRolesDialog.role.billing.description": "Contact for billing and payment issues, price updates, credits.",
  "dialog.UpdateContactRolesDialog.role.legal.label": "Legal",
  "dialog.UpdateContactRolesDialog.role.legal.description": "Contact for enforcement actions, contracts and terms and service updates.",
  "dialog.UpdateContactRolesDialog.role.invoiceRecipient.label": "Invoice recipient",
  "dialog.UpdateContactRolesDialog.role.invoiceRecipient.description": "Contact who receives new invoices. Without one, invoices go to the billing contacts, otherwise to the primary contact.",
  "dialog.UpdateContactRolesDialog.unknown": "Unknown",
  "dialog.DeleteContactDialog.headline": "Delete Contact",
  "dialog.DeleteContactDialog.submitLabel": "Delete",
  "dialog.DeleteContactDialog.confirmMessage": "Really delete contact \"{name}\"?",
  "dialog.DeleteContactDialog.warning": "This will also delete the corresponding contact in all applications connected with Cabana.",
  "dialog.RemoveContactDialog.headline": "Remove Contact",
  "dialog.RemoveContactDialog.submitLabel": "Remove",
  "dialog.RemoveContactDialog.confirmMessage": "Really remove contact {name} from customer {customer}?",
  "dialog.DeleteContactAttributeDialog.headline": "Delete Attribute",
  "dialog.DeleteContactAttributeDialog.submitLabel": "Delete",
  "dialog.DeleteContactAttributeDialog.confirmMessage": "Really delete attribute \"{name}\"?",
  "dialog.DeleteContactAttributeDialog.warning": "This action cannot be undone. The attribute value will be permanently removed from this contact.",
  "dialog.FinalizeInvoiceDialog.headline": "Finalize Invoice",
  "dialog.FinalizeInvoiceDialog.submitLabel": "Finalize",
  "dialog.FinalizeInvoiceDialog.question": "Proceed with finalizing this invoice for {customer}?",
  "dialog.FinalizeInvoiceDialog.hint": "An invoice number will be assigned and the invoice cannot be deleted anymore. Once finalized, the invoice is automatically sent to the configured contacts.",
  "dialog.SendInvoiceDialog.headline": "Send Invoice",
  "dialog.SendInvoiceDialog.submitLabel": "Send",
  "dialog.SendInvoiceDialog.question": "Send this invoice to the configured recipients?",
  "dialog.SendInvoiceDialog.alreadySentHint": "This invoice was already sent on {date}.",
  "dialog.DeleteInvoiceDialog.headline": "Delete Invoice",
  "dialog.DeleteInvoiceDialog.submitLabel": "Delete",
  "dialog.DeleteInvoiceDialog.confirmMessage": "Really delete invoice for {customer}?",
  "dialog.InitiateInvoicePaymentDialog.headline": "Initiate Payment",
  "dialog.InitiateInvoicePaymentDialog.submitLabel": "Initiate",
  "dialog.InitiateInvoicePaymentDialog.confirmMessage": "Initiate payment for invoice {number}?",
  "dialog.CreateCustomerDialog.headline": "Create Customer",
  "dialog.CreateCustomerDialog.customerNameLabel": "Customer name",
  "dialog.CreateCustomerDialog.customerNamePlaceholder": "Customer Name Ltd.",
  "dialog.CreateCustomerDialog.hint": "The customer name should be set to the official business name including its legal entity.",
  "dialog.DeleteCustomerDialog.headline": "Delete Customer",
  "dialog.DeleteCustomerDialog.submitLabel": "Delete",
  "dialog.DeleteCustomerDialog.confirmMessage": "Really delete customer \"{name}\"?",
  "dialog.DeleteCustomerDialog.warning": "This will also delete the corresponding customer in all applications connected with Cabana. Contacts are not removed.",
  "dialog.CreateProjectDialog.headline": "Create Project",
  "dialog.CreateProjectDialog.projectNameLabel": "Project name",
  "dialog.CreateProjectDialog.customerAccountLabel": "Customer account",
  "dialog.CreateProjectDialog.searchCustomerPlaceholder": "Search for a customer",
  "dialog.DeleteProjectDialog.headline": "Delete Project",
  "dialog.DeleteProjectDialog.submitLabel": "Delete",
  "dialog.DeleteProjectDialog.confirmMessage": "Really delete project \"{name}\"?",
  "dialog.ArchiveProjectDialog.headline": "Archive Project",
  "dialog.ArchiveProjectDialog.submitLabel": "Archive",
  "dialog.ArchiveProjectDialog.confirmMessage": "Really archive project \"{name}\"?",
  "dialog.ReactivateProjectDialog.headline": "Reactivate Project",
  "dialog.ReactivateProjectDialog.submitLabel": "Reactivate",
  "dialog.ReactivateProjectDialog.confirmMessage": "Really reactivate project \"{name}\"?",
  "dialog.CreateInvoiceDialog.headline": "Create Invoice",
  "dialog.CreateInvoiceDialog.customerAccountLabel": "Customer account",
  "dialog.DeletePaymentMethodDialog.headline": "Delete Payment Method",
  "dialog.DeletePaymentMethodDialog.submitLabel": "Delete",
  "dialog.DeletePaymentMethodDialog.confirmMessage": "Really delete payment method {type}?",
  "dialog.DeletePaymentMethodDialog.warning": "This will also delete the corresponding payment method in all applications connected with Cabana.",
  "dialog.SetDefaultPaymentMethodDialog.headline": "Set Default Payment Method",
  "dialog.SetDefaultPaymentMethodDialog.submitLabel": "Set as default",
  "dialog.UpdatePaymentTermsDialog.headline": "Update Payment Terms",
  "dialog.UpdatePaymentTermsDialog.submitLabel": "Update",
  "dialog.UpdatePaymentTermsDialog.paymentTermsLabel": "Payment terms",
  "dialog.UpdatePaymentTermsDialog.paymentTerms.uponReceipt": "Upon receipt",
  "dialog.UpdatePaymentTermsDialog.paymentTerms.net7": "Net 7",
  "dialog.UpdatePaymentTermsDialog.paymentTerms.net15": "Net 15",
  "dialog.UpdatePaymentTermsDialog.paymentTerms.net30": "Net 30",
  "dialog.UpdatePaymentTermsDialog.paymentTerms.net60": "Net 60",
  "dialog.CancelSubscriptionDialog.headline": "Cancel Subscription",
  "dialog.CancelSubscriptionDialog.submitLabel": "Schedule cancellation",
  "dialog.CancelSubscriptionDialog.confirmMessage": "Really cancel {service} subscription for {reference}?",
  "dialog.CancelSubscriptionDialog.hint": "{customer}'s subscription will expire at the end of this month.",
  "dialog.TerminateSubscriptionDialog.headline": "Terminate Subscription",
  "dialog.TerminateSubscriptionDialog.submitLabel": "Terminate immediately",
  "dialog.TerminateSubscriptionDialog.confirmMessage": "Really terminate {service} subscription for {reference}?",
  "dialog.TerminateSubscriptionDialog.hint": "{customer}'s subscription will expire immediately.",
  "dialog.InitiateInvoicePaymentDialog.description": "Trigger automatic payment of invoice {number} using {paymentMethod}?",
  "dialog.SetDefaultPaymentMethodDialog.confirmMessage": "Set {paymentMethodType} ending with {lastFourDigits} as the default payment method for {customer}?",
  "paymentMethod.SepaDebit": "SEPA direct debit",
  "paymentMethod.SepaDebit.description": "SEPA Direct Debit drawing from bank account ending with {lastFourDigits}",
  "paymentMethod.Card": "credit card",
  "paymentMethod.Card.description": "{cardBrand} card ending with {lastFourDigits}",
  "paymentMethod.Card.visa": "Visa credit card",
  "paymentMethod.Card.mastercard": "Mastercard credit card",
  "paymentMethod.unknown": "unknown payment method",
  "dialog.DeleteSettlementDialog.headline": "Delete Settlement",
  "dialog.DeleteSettlementDialog.submitLabel": "Delete",
  "dialog.DeleteSettlementDialog.confirmMessage": "Really delete settlement {id}?",
  "validation.field.required": "This field is required",
  "validation.field.nameTooLong": "This name is too long",
  "validation.field.nameTooShort": "This name is too short",
  "validation.field.nameContainsInvalidCharacters": "This name contains characters which are not allowed",
  "validation.field.emailAddressTooLong": "This email address is too long",
  "validation.field.emailAddressInvalid": "This is does not look like an email address",
  "validation.field.phoneNumberTooLong": "This phone number is too long",
  "validation.field.phoneNumberInvalid": "This does not look like a valid phone number",
  "validation.field.descriptionTooLong": "This description is too long",
  "validation.field.collectedAtInvalid": "Invalid date",
  "validation.field.collectedAtInFuture": "The date cannot be in the future",
  "validation.field.noteTooLong": "This note is too long",
  "validation.field.noteContainsInvalidCharacters": "This note contains invalid characters (e.g. < or >)",
  "errors.failedToDeleteContact": "Failed to delete contact.",
  "errors.failedToRemoveContact": "Failed to remove contact.",
  "errors.failedToAddContact": "Failed to add contact.",
  "errors.failedToUpdateContactRoles": "Failed to update contact roles.",
  "errors.failedToDeleteContactAttribute": "Failed to delete attribute.",
  "errors.failedToCreateTeamContact": "Failed to create team contact.",
  "errors.failedToUpdatePersonContact": "Failed to update person contact.",
  "errors.failedToUpdateTeamContact": "Failed to update team contact.",
  "errors.failedToSetPreferredLanguage": "Failed to set preferred language.",
  "errors.failedToFinalizeInvoice": "Failed to finalize invoice.",
  "errors.failedToSendInvoice": "Failed to send invoice.",
  "errors.failedToDeleteInvoice": "Failed to delete invoice.",
  "errors.failedToInitiatePayment": "Failed to initiate payment.",
  "errors.failedToCreateCustomer": "Failed to add customer.",
  "errors.failedToDeleteCustomer": "Failed to delete customer.",
  "errors.failedToCreateProject": "Failed to create project.",
  "errors.failedToDeleteProject": "Failed to delete project.",
  "errors.failedToArchiveProject": "Failed to archive project.",
  "errors.failedToReactivateProject": "Failed to reactivate project.",
  "errors.failedToCreateInvoice": "Failed to add invoice.",
  "errors.failedToDeletePaymentMethod": "Failed to delete payment method.",
  "errors.failedToSetDefaultPaymentMethod": "Failed to set default payment method.",
  "errors.failedToUpdatePaymentTerms": "Failed to update payment terms.",
  "errors.failedToCancelSubscription": "Failed to cancel subscription.",
  "errors.failedToTerminateSubscription": "Failed to terminate subscription.",
  "errors.failedToDeleteSettlement": "Failed to delete settlement.",
  "errors.failedToCreateAttributeDefinition": "Failed to create attribute definition.",
  "errors.failedToDeleteAttributeDefinition": "Failed to delete attribute definition.",
  "errors.failedToCreateReverseInvoice": "Failed to create reverse invoice.",
  "errors.failedToCreateSubscription": "Failed to create subscription.",
  "errors.failedToCreateTermsAndConditionsDocument": "Failed to create terms and conditions document.",
  "errors.failedToSetUpPaymentMethod": "Failed to set up payment method.",
  "errors.failedToSetUpStripePayment": "Failed to set up Stripe payment.",
  "errors.failedToUpdateCustomerOrderNotes": "Failed to update customer order notes.",
  "errors.failedToUpdatePurchaseOrderReference": "Failed to update purchase order reference.",
  "button.cancel": "Cancel",
  "button.confirm": "Confirm",
  "button.create": "Create",
  "combobox.loading": "Loading …",
  "combobox.noResults": "No results",
  "button.save": "Save",
  "button.saving": "Saving…",
  "button.edit": "Edit",
  "button.delete": "Delete",
  "button.update": "Update",
  "button.add": "Add",
  "button.remove": "Remove",
  "button.submit": "Submit",
  "button.show": "Show",
  "validation.field.attributeNamePattern": "Name must follow pattern \"namespace.attribute_name\" (lowercase letters, numbers, underscores)",
  "validation.field.labelTooShort": "Label is too short",
  "validation.field.labelTooLong": "Label is too long",
  "validation.field.invalidType": "Invalid type",
  "validation.field.titleTooShort": "Title is too short",
  "validation.field.titleTooLong": "Title is too long",
  "validation.field.invalidCode": "Invalid code",
  "validation.field.invalidVersion": "Invalid version",
  "validation.field.invalidUri": "Invalid URI",
  "validation.field.invalidDate": "Invalid date",
  "attributeDefinition.name": "Name",
  "attributeDefinition.name.hint": "Use namespace.attribute_name format (e.g., platform.last_login, custom.industry)",
  "attributeDefinition.label": "Label",
  "attributeDefinition.label.placeholder": "Last Login Date",
  "attributeDefinition.label.hint": "Human-readable label for this attribute",
  "attributeDefinition.type": "Type",
  "attributeDefinition.type.string": "String",
  "attributeDefinition.type.integer": "Integer",
  "attributeDefinition.type.date": "Date",
  "attributeDefinition.type.boolean": "Boolean",
  "attributeDefinition.entityTypes": "Supported Entity Types",
  "attributeDefinition.entityTypes.contact": "Contact",
  "attributeDefinition.entityTypes.account": "Account",
  "attributeDefinition.entityTypes.hint": "Select which entity types can use this attribute",
  "dialog.CreateAttributeDefinitionDialog.headline": "Create Attribute Definition",
  "dialog.DeleteAttributeDefinitionDialog.headline": "Delete Attribute Definition",
  "dialog.DeleteAttributeDefinitionDialog.confirmMessage": "Really delete attribute definition \"{name}\"?",
  "dialog.DeleteAttributeDefinitionDialog.warning": "This action cannot be undone. Existing attribute values will remain but no new values can be set for this attribute.",
  "dialog.CreateReverseInvoiceDialog.headline": "Reverse Invoice",
  "dialog.CreateReverseInvoiceDialog.question": "Create a reverse invoice for {invoiceNumber}?",
  "dialog.CreateReverseInvoiceDialog.hint": "A new reverse invoice will be created as a draft invoice. Nothing is sent to {customer} and no payments are canceled until the reverse invoice was finalized.",
  "dialog.CreateSubscriptionDialog.headline": "Create Subscription",
  "subscription.customerAccount": "Customer account",
  "subscription.subscriptionService": "Subscription service",
  "subscription.subscriptionServiceReference": "Subscription service reference",
  "subscription.subscriptionServiceReference.placeholder": "For example the UUID of a Beach organization",
  "subscription.subscriptionServiceReferenceLabel": "Subscription service reference label",
  "subscription.subscriptionServiceReferenceLabel.placeholder": "For example the name of a Beach organization",
  "subscription.subscriptionServiceReferenceUri": "Subscription service reference URI",
  "subscription.orderedAt": "Order date",
  "subscription.activateAt": "Start date",
  "subscription.settlementType": "Settlement type",
  "subscription.customerOrderNotes": "Customer order notes",
  "subscription.customerOrderNotes.placeholder": "Ordered by John Doe",
  "subscription.customerOrderNotes.editPlaceholder": "e.g. ordered by Julia Higgins",
  "subscription.purchaseOrderReference": "Purchase order reference",
  "subscription.purchaseOrderReference.editPlaceholder": "e.g. PO-12348-887ah8",
  "dialog.CreateTermsAndConditionsDocumentDialog.headline": "Create Terms & Conditions",
  "termsAndConditions.code": "Code",
  "termsAndConditions.title": "Title",
  "termsAndConditions.title.placeholder": "General Terms of Service",
  "termsAndConditions.version": "Version",
  "termsAndConditions.uri": "URI",
  "termsAndConditions.startDate": "Start date",
  "termsAndConditions.publishDate": "Publish date",
  "termsAndConditions.published": "Published",
  "dialog.SetUpOnAccountPaymentMethodDialog.headline": "Add payment on account",
  "paymentMethod.paymentTerms": "Payment terms",
  "paymentMethod.paymentTerms.uponReceipt": "Due net, upon receipt",
  "paymentMethod.paymentTerms.net7": "Due net, 7 days",
  "paymentMethod.paymentTerms.net15": "Due net, 15 days",
  "paymentMethod.paymentTerms.net30": "Due net, 30 days",
  "paymentMethod.paymentTerms.net60": "Due net, 60 days",
  "dialog.SetUpStripePaymentMethodDialog.headline": "Set Up Payment Method",
  "language.german": "German",
  "language.english": "English",
  "view.customerAccount.headline": "Account Information",
  "customer.field.customerNumber": "Customer Number",
  "customer.field.customerName": "Customer Name",
  "customer.field.customerName.placeholder": "Customer Name Ltd.",
  "customer.field.businessAddress": "Business Address",
  "customer.field.addressLine1.placeholder": "Street address",
  "customer.field.addressLine2.placeholder": "Additional address information",
  "customer.field.postalCode.placeholder": "Postal code",
  "customer.field.city.placeholder": "City",
  "customer.field.vatId": "VAT ID",
  "customer.field.vatId.placeholder": "DE999999999",
  "customer.field.taxStatus": "Tax status",
  "customer.field.preferredLanguage": "Preferred language",
  "customer.taxStatus.unknown": "Unknown",
  "customer.taxStatus.regular": "Regular",
  "customer.taxStatus.exempt": "Exempt",
  "customer.taxStatus.reverseCharge": "Reverse Charge",
  "validation.field.customerNameTooShort": "This customer name is too short",
  "validation.field.customerNameTooLong": "This customer name is too long",
  "validation.field.vatIdTooShort": "This VAT ID is too short",
  "validation.field.vatIdTooLong": "This VAT ID is too long",
  "validation.field.vatIdInvalid": "This does not look like a valid VAT ID",
  "validation.field.invalidTaxStatus": "Invalid tax status",
  "validation.field.businessNameTooShort": "This business name is too short",
  "validation.field.businessNameTooLong": "This business name is too long",
  "validation.field.postalCodeInvalid": "Invalid postal code",
  "validation.field.cityInvalid": "Invalid city name",
  "validation.field.orderNotesTooLong": "The order notes are too long",
  "validation.field.invalidOrderNotes": "Invalid order notes",
  "validation.field.invalidPurchaseOrderReference": "Invalid purchase order reference",
  "errors.failedToUpdateCustomerName": "Failed to update customer name.",
  "errors.failedToUpdateBusinessAddress": "Failed to update business address.",
  "errors.failedToUpdateVatId": "Failed to update VAT ID.",
  "errors.failedToUpdateTaxStatus": "Failed to update tax status.",
  "errors.failedToUpdatePreferredLanguage": "Failed to update preferred language.",
  "button.deleteAccount": "Delete Account",
  "button.downloadPdf": "Download PDF",
  "button.finalize": "Finalize...",
  "button.refresh": "Refresh",
  "button.reverseInvoice": "Reverse invoice…",
  "button.initiatePayment": "Initiate payment…",
  "button.sendToCustomer": "Send to customer…",
  "button.deleteProject": "Delete Project",
  "button.archiveProject": "Archive Project",
  "button.reactivateProject": "Reactivate Project",
  "invoice.field.documentLanguage": "Document language",
  "invoice.field.invoiceNumber": "Invoice number",
  "invoice.field.invoiceDate": "Invoice date",
  "invoice.field.relatedInvoice": "Related invoice",
  "invoice.field.dueDate": "Due date",
  "invoice.field.periodOfPerformance": "Period of performance",
  "invoice.field.purchaseOrderReference": "PO reference",
  "invoice.field.customerOrderNotes": "Customer order notes",
  "invoice.field.state": "State",
  "invoice.field.totalGrossAmount": "Total gross amount",
  "invoice.document.outdated": "The document is currently being re-created. The previous version is shown.",
  "invoice.document.notRenderedYet": "No document has been created for this invoice yet.",
  "invoice.document.unavailable": "The document for this invoice is currently not available.",
  "invoice.document.loadFailed": "The preview could not be loaded.",
  "pdfViewer.pageOfPages": "Page {current} of {total}",
  "invoice.section.notes": "Notes",
  "invoice.section.attachments": "Attachments",
  "invoice.section.payment": "Payment",
  "invoice.attachment.upload": "Upload attachments",
  "invoice.attachment.dragAndDrop": "or drag and drop",
  "invoice.attachment.sizeLimit": "PDF up to 10MB",
  "invoice.email.wasSentOn": "was sent on",
  "invoice.email.label": "Invoice Email",
  "invoice.payment.paidOn": "paid on",
  "invoice.payment.inProgressSince": "payment in progress since",
  "invoice.payment.scheduledFor": "scheduled for",
  "invoice.payment.dueOn": "due on",
  "invoice.payment.net7Days": "Net 7 days",
  "invoice.payment.net15Days": "Net 15 days",
  "invoice.payment.net30Days": "Net 30 days",
  "invoice.payment.net60Days": "Net 60 days",
  "invoice.payment.paymentMethod": "Payment Method",
  "invoice.payment.succeededAt": "succeeded at",
  "invoice.payment.wasCanceledAt": "was canceled at",
  "invoice.payment.wasCreatedAt": "was created at",
  "invoice.payment.createdAt": "created at",
  "invoice.payment.paymentIntent": "Payment Intent",
  "invoice.payment.charge": "Charge",
  "invoice.payment.refund": "Refund",
  "invoice.payment.chargeDisputed": "This charge was disputed.",
  "invoice.payment.chargeRefunded": "This charge was refunded.",
  "invoice.payment.sepaDirectDebitFrom": "SEPA Direct Debit drawing from bank account ending with {lastFourDigits}.",
  "invoice.payment.chargingCard": "Charging {cardBrand} card ending with {lastFourDigits}.",
  "invoice.payment.chargeFailure.referToCustomer": "The bank did not return any further details with this decline.",
  "invoice.payment.chargeFailure.expiredCard": "The bank returned that the card has expired.",
  "invoice.payment.chargeFailure.cardDecline": "The bank declined the card.",
  "invoice.payment.chargeFailure.incorrectNumber": "The bank returned that the card number is incorrect.",
  "errors.failedToUpdateTimeOfPerformance": "Failed to update time of performance.",
  "errors.failedToDownloadPdf": "Failed to download PDF.",
  "errors.failedToRefreshPdf": "Failed to refresh PDF.",
  "project.field.projectName": "Project Name",
  "project.field.documentLanguage": "Document language",
  "project.field.billing": "Billing",
  "project.field.billingMode": "Billing mode",
  "project.field.hourlyRate": "Hourly rate (in Euro Cents)",
  "project.field.fixedFee": "Fixed fee (in Euro Cents)",
  "project.field.purchaseOrderReference": "Purchase order reference",
  "project.field.customerOrderNotes": "Customer order notes",
  "project.billingMode.nonBillable": "Non-billable",
  "project.billingMode.timeAndMaterials": "Time and materials",
  "project.billingMode.fixedFee": "Fixed fee",
  "project.billing.timeAndMaterialsCharge": "Time and materials, charging {hourlyRate} per hour",
  "project.billing.fixedFeeCharge": "Fixed fee, charging {fixedFee} in total",
  "errors.failedToRenameProject": "Failed to rename project.",
  "errors.failedToUpdateProjectBilling": "Failed to update project billing.",
  "navigation.dashboard": "Dashboard",
  "navigation.sidebar": "Sidebar",
  "navigation.closeSidebar": "Close sidebar",
  "navigation.collapseSidebar": "Collapse sidebar",
  "navigation.expandSidebar": "Expand sidebar",
  "list.invoice.header.state": "State",
  "list.invoice.header.invoiceDate": "Invoice Date",
  "list.invoice.header.dueDate": "Due Date",
  "list.invoice.header.invoiceNumber": "Invoice No.",
  "list.invoice.header.customer": "Customer",
  "list.invoice.header.total": "Invoice Total",
  "list.invoice.action.delete": "Delete invoice",
  "list.invoice.action.edit": "Edit invoice",
  "list.invoice.action.show": "Show invoice",
  "list.invoice.state.draft": "Draft",
  "list.invoice.state.invoiceNumberPending": "Number pending",
  "list.invoice.state.open": "Open",
  "list.invoice.state.paid": "Paid",
  "list.invoice.state.refunded": "Refunded",
  "list.invoice.state.reversed": "Reversed",
  "list.invoice.state.uncollectible": "Uncollectible",
  "list.invoice.state.void": "Void",
  "list.invoice.legend.title": "Legend",
  "list.invoice.legend.paymentIsFailing": "Payment is failing",
  "list.invoice.legend.paymentIsOverdue14": "Overdue by 14 days or more",
  "list.invoice.legend.paymentIsOverdue30": "Overdue by 30 days or more",
  "list.project.header.state": "State",
  "list.project.header.projectNumber": "Project No.",
  "list.project.header.project": "Project",
  "list.project.header.customer": "Customer",
  "list.project.header.rate": "Rate",
  "list.project.state.archived": "Archived",
  "list.project.state.active": "Active",
  "list.project.billingMode.nonBillable": "Non Billable",
  "list.project.billingMode.fixedFee": "Fixed Fee",
  "list.project.action.show": "Show project",
  "list.settlement.header.state": "State",
  "list.settlement.header.cutOffDate": "Cut Off Date",
  "list.settlement.header.customer": "Customer",
  "list.settlement.header.service": "Service",
  "list.settlement.header.description": "Description",
  "list.settlement.header.netTotal": "Net Total",
  "header.invoice.type.reverse": "Reverse Invoice",
  "header.invoice.type.invoice": "Invoice",
  "header.project.billingMode.timeAndMaterials": "Time and materials",
  "header.project.billingMode.fixedFee": "Fixed fee",
  "header.project.billingMode.nonBillable": "Non-billable",
  "header.project.state.archived": "Archived",
  "header.project.state.active": "Active",
  "header.settlement.status.open": "Open",
  "header.settlement.status.invoiced": "Invoiced",
  "header.settlement.status.finalized": "Finalized",
  "header.settlement.status.closed": "Closed",
  "header.settlement.status.unknown": "Unknown",
  "search.label": "Search",
  "search.placeholder": "Search for anything",
  "profile.headline": "User Profile",
  "profile.fullName": "Full name",
  "profile.namePlaceholder": "Name",
  "profile.emailAddress": "Email address",
  "profile.emailPlaceholder": "Email",
  "button.loadMore": "Load more",
  "button.deleteContact": "Delete Contact",
  "view.contactData.name": "Name",
  "view.dataProtection.dataOrigins": "Data Origins",
  "view.customerContacts.headline": "Customer Contacts",
  "view.customerContacts.noContacts": "No contacts",
  "view.customerContacts.noContactsDescription": "Assign the first contact to this customer.",
  "view.customerContacts.addContact": "Add contact",
  "view.customerContacts.people": "People",
  "view.customerContacts.teams": "Teams",
  "view.payment.headline": "Payment Methods",
  "view.payment.noPaymentMethods": "No payment methods found",
  "view.payment.noPaymentMethodsDescription": "Set up a credit card or SEPA direct debit mandate for this customer",
  "view.payment.addCardOrSepa": "Add card or SEPA",
  "view.payment.addOnAccount": "Add on account",
  "view.projectPayment.headline": "Payment Method",
  "view.projectPayment.notImplemented": "Custom payment methods for projects are not implemented yet.",
  "list.paymentMethod.header.type": "Type",
  "list.paymentMethod.header.number": "Number",
  "list.paymentMethod.header.details": "Details",
  "list.paymentMethod.header.status": "Status",
  "list.paymentMethod.status.default": "Default",
  "paymentMethod.OnAccount": "On account",
  "view.contacts.headline": "Contacts",
  "view.contacts.createButton": "Create contact",
  "view.contacts.searchPlaceholder": "Search Contacts",
  "view.subscriptions.headline": "Subscriptions",
  "view.subscriptions.createButton": "Create subscription",
  "view.subscriptions.searchPlaceholder": "Search Subscriptions",
  "view.subscriptions.terminateButton": "Terminate subscription",
  "view.subscriptions.cancelButton": "Cancel subscription",
  "view.projects.headline": "Projects",
  "view.projects.createButton": "Create project",
  "view.projects.searchPlaceholder": "Search Projects",
  "view.customers.headline": "Customers",
  "view.customers.createButton": "Create customer",
  "view.customers.searchPlaceholder": "Search Customers",
  "view.settlements.headline": "Settlements",
  "view.settlements.searchPlaceholder": "Search Settlements",
  "tab.invoices.outgoing": "Outgoing invoices",
  "tab.invoices.incoming": "Incoming invoices",
  "tab.invoices.suppliers": "Suppliers",
  "view.invoices.headline": "Outgoing invoices",
  "view.invoices.createButton": "Create invoice",
  "view.invoices.searchPlaceholder": "Search Invoices",
  "view.invoices.searchLabel": "Search",
  "view.invoices.filter.active": "Active",
  "view.invoices.filter.overdue": "Overdue",
  "view.invoices.filter.done": "Done",
  "view.invoices.filter.all": "All",
  "view.configurationContracts.headline": "Terms and Conditions",
  "view.configurationContracts.createButton": "Create terms and conditions",
  "view.configurationContracts.ariaLabel": "Terms and Conditions",
  "view.configurationContracts.table.id": "ID",
  "view.configurationContracts.table.code": "Code",
  "view.configurationContracts.table.title": "Title",
  "view.configurationContracts.table.version": "Version",
  "view.configurationContracts.table.uri": "URI",
  "view.configurationContracts.table.startDate": "Start Date",
  "view.configurationContracts.noDocuments": "No terms and conditions documents found.",
  "view.configurationContracts.loading": "Loading...",
  "view.configurationAttributeDefinitions.headline": "Attribute Definitions",
  "view.configurationAttributeDefinitions.createButton": "Create attribute definition",
  "view.configurationAttributeDefinitions.ariaLabel": "Attribute Definitions",
  "view.configurationAttributeDefinitions.table.name": "Name",
  "view.configurationAttributeDefinitions.table.label": "Label",
  "view.configurationAttributeDefinitions.table.type": "Type",
  "view.configurationAttributeDefinitions.table.entityTypes": "Entity Types",
  "view.configurationAttributeDefinitions.noDefinitions": "No attribute definitions found.",
  "view.subscription.status": "Status",
  "view.subscription.customerAccount": "Customer account",
  "view.subscription.service": "Service",
  "view.subscription.serviceReference": "Service reference",
  "view.subscription.notFound": "Subscription not found",
  "view.subscription.assigningNumber": "Assigning invoice number",
  "view.subscription.panel.headline": "Subscription",
  "view.subscription.status.expiredAt": "Expired at {date}",
  "view.subscription.status.canceledWillExpireAt": "Canceled, will expire at {date}",
  "view.subscription.status.activeSince": "Active since {date}",
  "list.subscription.state.scheduled": "Scheduled",
  "list.subscription.state.active": "Active",
  "list.subscription.state.canceled": "Canceled",
  "list.subscription.state.expired": "Expired",
  "common.loading": "Loading...",
  "common.unsavedChanges": "Unsaved changes",
  "contact.emailAddress.buttonTitle": "Email address",
  "contact.phoneNumber.buttonTitle": "Phone number",
  "detailedContactList.editRoles": "Edit roles",
  "attributeDefinition.deleteButton": "Delete attribute definition",
  "dialog.placeholder.manual": "Manual",
  "dialog.placeholder.purchaseOrder": "PO-1234567",
  "dialog.placeholder.datetime": "YYYY-MM-DD HH:MM:SS",
  "dialog.placeholder.confirmProjectName": "Enter project name to confirm",
  "dialog.placeholder.enterValue": "Enter value...",
  "dialog.placeholder.enterNumber": "Enter number...",
  "breadcrumb.configuration": "Configuration",
  "breadcrumb.contacts": "Contacts",
  "breadcrumb.customers": "Customers",
  "breadcrumb.projects": "Projects",
  "breadcrumb.settlements": "Settlements",
  "tab.configuration": "Configuration",
  "tab.marketing.emails": "Emails",
  "tab.marketing.lists": "Lists",
  "tab.marketing.templates": "Templates",
  "tab.contracts": "Contracts",
  "tab.attributes": "Attributes",
  "tab.finance": "Finance",
  "tab.contact": "Contact",
  "tab.dataProtection": "Data Protection",
  "tab.customer": "Customer",
  "tab.contacts": "Contacts",
  "tab.payment": "Payment",
  "tab.project": "Project",
  "tab.activities": "Activities",
  "tab.english": "English",
  "tab.german": "German",
  "activity.recentActivity": "Recent Activity",
  "activity.noActivities": "No activities yet",
  "activity.today": "Today",
  "activity.yesterday": "Yesterday",
  "activity.viewTicket": "View ticket",
  "activity.viewAll": "View all activities",
  "activity.cabana.contact.created": "Contact was created",
  "activity.cabana.contact.updated": "Contact was updated",
  "activity.cabana.contact.assigned_to_customer": "Was assigned to customer account {customerName}",
  "activity.cabana.contact.removed_from_customer": "Was removed from customer account {customerName}",
  "activity.cabana.contact.role_assigned": "Role {roleIdentifier} was assigned for {customerName}",
  "activity.cabana.contact.role_unassigned": "Role {roleIdentifier} was removed for {customerName}",
  "activity.cabana.contact.attribute_changed": "Attribute {attributeName} was changed",
  "activity.cabana.contact.attribute_removed": "Attribute {attributeName} was removed",
  "activity.cabana.contact.email_changed": "Email address was changed",
  "activity.zammad.ticket.created": "New ticket: {ticketTitle} (#{ticketNumber})",
  "activity.zammad.ticket.updated": "Ticket #{ticketNumber} was updated",
  "activity.zammad.ticket.closed": "Ticket \"{ticketTitle}\" was closed (#{ticketNumber})",
  "activity.zammad.ticket.reopened": "Ticket \"{ticketTitle}\" was reopened (#{ticketNumber})",
  "activity.zammad.ticket.article_added": "New reply on ticket \"{ticketTitle}\" (#{ticketNumber})",
  "activity.cabana.customer_account.created": "Customer account was created",
  "activity.cabana.customer_account.renamed": "Customer account was renamed",
  "activity.cabana.customer_account.address_updated": "Business address was updated",
  "activity.cabana.customer_account.tax_info_updated": "VAT ID was updated",
  "activity.cabana.customer_account.tax_status_updated": "Tax status was changed to {taxStatus}",
  "activity.cabana.customer_account.payment_method_changed": "Default payment method was changed",
  "activity.cabana.customer_account.language_updated": "Preferred language was changed to {language}",
  "activity.cabana.customer_account.contact_added": "Contact {contactName} was added",
  "activity.cabana.customer_account.contact_removed": "Contact {contactName} was removed",
  "activity.cabana.customer_account.contact_role_assigned": "Role {roleIdentifier} was assigned to {contactName}",
  "activity.cabana.customer_account.contact_role_unassigned": "Role {roleIdentifier} was removed from {contactName}",
  "activity.cabana.list.subscribed": "Contact was added to list \"{mailingListName}\"",
  "activity.cabana.list.unsubscribed": "Contact unsubscribed from list \"{mailingListName}\"",
  "activity.cabana.list.removed": "Contact was removed from list \"{mailingListName}\"",
  "activity.cabana.list.resubscribed": "Contact was re-added to list \"{mailingListName}\"",
  "activity.cabana.email.sent": "Email \"{subject}\" was sent",
  "activity.cabana.email.delivered": "Email \"{subject}\" was delivered",
  "activity.cabana.email.bounced": "Email \"{subject}\" bounced",
  "activity.cabana.email.failed": "Email \"{subject}\" failed to send",

  "navigation.marketingEmails": "Marketing Emails",
  "navigation.mailingLists": "Lists",
  "navigation.emailTemplates": "Email Templates",

  "view.marketingEmails.headline": "Marketing Emails",
  "view.marketingEmails.createButton": "Create marketing email",
  "view.marketingEmails.searchPlaceholder": "Search Marketing Emails",
  "view.marketingEmails.noMarketingEmails": "No marketing emails found",
  "view.marketing.headline": "Marketing",

  "view.mailingLists.headline": "Lists",
  "view.mailingLists.createButton": "Create list",
  "view.mailingLists.searchPlaceholder": "Search Lists",
  "view.mailingLists.noMailingLists": "No lists found",

  "view.emailTemplates.headline": "Email Templates",
  "view.emailTemplates.createButton": "Create template",
  "view.emailTemplates.searchPlaceholder": "Search Templates",
  "view.emailTemplates.noEmailTemplates": "No email templates found",
  "view.emailTemplates.showUsedOneTime": "Show used one-time templates",

  "breadcrumb.marketingEmails": "Marketing Emails",
  "breadcrumb.marketing": "Marketing",
  "breadcrumb.mailingLists": "Lists",
  "breadcrumb.emailTemplates": "Email Templates",
  "breadcrumb.templates": "Templates",

  "tab.marketingEmail.overview": "Overview",
  "tab.marketingEmail.details": "Details",
  "tab.marketingEmail.delivery": "Delivery",
  "tab.marketingEmail.delivery.locked": "Available after sending",
  "tab.marketingEmail.unsubscribes": "Unsubscribes",
  "tab.marketingEmail.unsubscribes.locked": "Available after sending",
  "tab.mailingList.details": "Details",
  "tab.mailingList.members": "Members",
  "tab.emailTemplate.details": "Details",

  "marketingEmail.notFound": "Marketing email not found",
  "marketingEmail.status.draft": "Draft",
  "marketingEmail.status.sending": "Sending",
  "marketingEmail.status.sent": "Sent",
  "marketingEmail.status.partiallySent": "Partially Sent",
  "marketingEmail.field.name": "Name",
  "marketingEmail.field.status": "Status",
  "marketingEmail.field.mailingList": "List",
  "marketingEmail.field.mailingListPlaceholder": "Search for a list",
  "marketingEmail.field.emailTemplate": "Email Template",
  "marketingEmail.field.emailTemplatePlaceholder": "Search for an email template",
  "marketingEmail.field.emailLayout": "Email Layout",
  "marketingEmail.field.emailLayoutPlaceholder": "Search for a layout",
  "marketingEmail.field.sender": "Sender",
  "marketingEmail.field.senderName": "Sender Name",
  "marketingEmail.field.senderEmail": "Sender Email",
  "marketingEmail.field.replyToEmail": "Reply-To Email",
  "marketingEmail.field.subject": "Subject",
  "marketingEmail.field.preheader": "Preheader",
  "marketingEmail.field.recipientCount": "Recipient Count",
  "marketingEmail.section.recipients": "Recipients",
  "marketingEmail.section.template": "Template",
  "marketingEmail.section.layout": "Layout",
  "marketingEmail.section.sender": "Sender",
  "marketingEmail.section.content": "Content",
  "marketingEmail.subscribers": "subscribers",
  "marketingEmail.noMailingList": "No list selected",
  "marketingEmail.noTemplate": "No template selected",
  "marketingEmail.noLayout": "No layout selected",
  "marketingEmail.defaultLayout": "(default layout)",
  "marketingEmail.noSender": "No sender configured",
  "marketingEmail.noSubject": "No subject configured",
  "marketingEmail.panel.info": "Marketing Email",
  "marketingEmail.panel.email": "Email",
  "marketingEmail.panel.content": "Content",
  "marketingEmail.field.recipients": "Recipients",
  "marketingEmail.field.replyTo": "Reply to",
  "marketingEmail.preview.plainText": "Text",
  "marketingEmail.preview.preheader": "Preview text",
  "marketingEmail.preview.noTemplate": "Select an email template to see a preview",
  "marketingEmail.preview.noPreheader": "No preview text",
  "marketingEmail.preview.title": "Preview",
  "marketingEmail.preview.error": "Failed to load preview",

  "mailingList.notFound": "List not found",
  "mailingList.status.archived": "Archived",
  "mailingList.field.name": "Name",
  "mailingList.field.description": "Description",
  "mailingList.field.subscribedCount": "Subscribed",
  "mailingList.field.unsubscribedCount": "Unsubscribed",
  "mailingList.field.createdAt": "Created",
  "mailingList.noDescription": "No description",
  "mailingList.noMembers": "No members in this list",
  "mailingList.members": "Members",
  "mailingList.member.status.subscribed": "Subscribed",
  "mailingList.member.status.unsubscribed": "Unsubscribed",
  "mailingList.field.subscriptionReason": "Subscription reason",
  "mailingList.field.type": "Type",
  "mailingList.field.criterion": "Criterion",
  "mailingList.type.static": "Static (manual members)",
  "mailingList.type.dynamic": "Dynamic (by contact attribute)",
  "mailingList.criterion.operator.equals": "equals",
  "mailingList.criterion.operator.exists": "is set",
  "mailingList.criterion.value.true": "true",
  "mailingList.criterion.value.false": "false",
  "mailingList.criterion.condition.equals": "{attribute} = {value}",
  "mailingList.criterion.condition.exists": "{attribute} is set",
  "mailingList.dynamicMembers": "Current members ({count})",
  "mailingList.dynamicMembers.loading": "Loading members …",
  "mailingList.dynamicMembers.truncated": "Only the first {count} matches are shown.",
  "mailingList.unsubscribedMembers": "Unsubscribed contacts ({count})",
  "mailingList.noUnsubscribedMembers": "No unsubscribed contacts",
  "mailingList.subscriptionReason.defaultText.de": "Du bekommst diese E-Mail, weil du {listName} abonniert hast.",
  "mailingList.subscriptionReason.defaultText.en": "You are receiving this email because you subscribed to {listName}.",

  "dialog.EditSubscriptionReasonDialog.headline": "Edit subscription reason",

  "errors.failedToUpdateSubscriptionReason": "Failed to update subscription reason",

  "emailTemplate.notFound": "Email template not found",
  "emailTemplate.field.name": "Name",
  "emailTemplate.field.usageCount": "Used in marketing emails",
  "emailTemplate.field.createdAt": "Created",
  "emailTemplate.field.updatedAt": "Last updated",
  "emailTemplate.field.content": "Content",
  "emailTemplate.field.htmlContent": "HTML Content",
  "emailTemplate.field.textContent": "Plain Text Content",
  "emailTemplate.section.content": "Content",
  "emailTemplate.hasContent": "Content configured",
  "emailTemplate.noContent": "No content configured",
  "emailTemplate.tab.preview": "Preview",
  "emailTemplate.tab.edit": "Edit",
  "emailTemplate.tab.html": "HTML",
  "emailTemplate.preview.title": "Preview",
  "emailTemplate.preview.plainText": "Plain Text",
  "emailTemplate.preview.noContent": "No content to preview",
  "emailTemplate.action.startEditing": "Start editing",
  "emailTemplate.placeholder.htmlContent": "Enter the HTML content of your email here...",
  "emailTemplate.placeholder.textContent": "Enter the plain text version here...",
  "emailTemplate.generateFromHtml": "Generate from HTML",

  "richTextEditor.paragraph": "Paragraph",
  "richTextEditor.heading1": "Heading 1",
  "richTextEditor.heading2": "Heading 2",
  "richTextEditor.heading3": "Heading 3",
  "richTextEditor.bold": "Bold",
  "richTextEditor.italic": "Italic",
  "richTextEditor.bulletList": "Bullet List",
  "richTextEditor.orderedList": "Numbered List",
  "richTextEditor.addLink": "Add Link",
  "richTextEditor.removeLink": "Remove Link",
  "richTextEditor.insertLink": "Insert",
  "richTextEditor.insertVariable": "Insert Variable",

  "templateVariable.group.contact": "Contact",
  "templateVariable.group.customerAccount": "Customer",
  "templateVariable.group.other": "Other",
  "templateVariable.contact.givenName": "Given Name",
  "templateVariable.contact.familyName": "Family Name",
  "templateVariable.contact.fullName": "Full Name",
  "templateVariable.contact.emailAddress": "Email Address",
  "templateVariable.contact.salutation": "Salutation",
  "templateVariable.contact.teamName": "Team Name",
  "templateVariable.customerAccount.customerName": "Customer Name",
  "templateVariable.subscriptionPreferencesUrl": "Subscription Preferences Link",

  "list.marketingEmail.header.status": "Status",
  "list.marketingEmail.header.name": "Name",
  "list.marketingEmail.header.mailingList": "List",
  "list.marketingEmail.header.subject": "Subject",
  "list.marketingEmail.header.recipients": "Recipients",
  "list.marketingEmail.header.sentAt": "Sent",
  "list.marketingEmail.action.show": "Show marketing email",

  "list.mailingList.header.name": "Name",
  "list.mailingList.header.description": "Description",
  "list.mailingList.header.subscribed": "Subscribed",
  "list.mailingList.header.unsubscribed": "Unsubscribed",
  "list.mailingList.header.createdAt": "Created",
  "list.mailingList.action.show": "Show list",

  "list.mailingListMember.header.status": "Status",
  "list.mailingListMember.header.name": "Name",
  "list.mailingListMember.header.email": "Email",
  "list.mailingListMember.header.subscribedAt": "Subscribed",
  "list.mailingListMember.header.unsubscribedAt": "Unsubscribed",

  "list.emailTemplate.header.name": "Name",
  "list.emailTemplate.header.type": "Type",
  "list.emailTemplate.header.usageCount": "Usage",
  "list.emailTemplate.header.createdAt": "Created",
  "list.emailTemplate.header.updatedAt": "Updated",
  "list.emailTemplate.action.show": "Show template",
  "list.emailTemplate.type.reusable": "Reusable",
  "list.emailTemplate.type.oneTime": "One-time",
  "list.emailTemplate.type.used": "Used",

  "dialog.CreateMarketingEmailDialog.headline": "Create Marketing Email",
  "dialog.CreateMarketingEmailDialog.nameLabel": "Name",
  "dialog.CreateMarketingEmailDialog.namePlaceholder": "Newsletter January 2026",

  "dialog.ArchiveMarketingEmailDialog.headline": "Archive Marketing Email",
  "dialog.ArchiveMarketingEmailDialog.confirmMessage": "Are you sure you want to archive the marketing email \"{name}\"?",

  "dialog.LaunchMarketingEmailDialog.headline": "Launch Marketing Email",
  "dialog.LaunchMarketingEmailDialog.confirmMessage": "You are about to send this marketing email to all recipients. This action cannot be undone.",
  "dialog.LaunchMarketingEmailDialog.warning": "Emails will be sent immediately after launching.",
  "dialog.LaunchMarketingEmailDialog.noRecipients": "This marketing email has no recipients. Please select a mailing list with at least one subscriber.",

  "dialog.SendMarketingEmailTestEmailDialog.headline": "Send Test Email",
  "dialog.SendMarketingEmailTestEmailDialog.description": "Send a test email for marketing email \"{name}\" to verify the content before launching.",
  "dialog.SendMarketingEmailTestEmailDialog.recipientEmailLabel": "Recipient Email",
  "dialog.SendMarketingEmailTestEmailDialog.sampleContactLabel": "Sample Contact",
  "dialog.SendMarketingEmailTestEmailDialog.sampleContactPlaceholder": "Search for a contact...",
  "dialog.SendMarketingEmailTestEmailDialog.sampleContactHint": "The sample contact's data will be used to fill in placeholders in the email template. If no contact is selected, placeholder data will be used.",

  "dialog.CreateMailingListDialog.headline": "Create List",
  "dialog.CreateMailingListDialog.nameLabel": "Name",
  "dialog.CreateMailingListDialog.namePlaceholder": "Newsletter Subscribers",
  "dialog.CreateMailingListDialog.descriptionLabel": "Description",
  "dialog.CreateMailingListDialog.descriptionPlaceholder": "Subscribers to our monthly newsletter",
  "dialog.CreateMailingListDialog.typeLabel": "List type",
  "dialog.CreateMailingListDialog.attributeLabel": "Contact attribute",
  "dialog.CreateMailingListDialog.attributePlaceholder": "Choose attribute …",
  "dialog.CreateMailingListDialog.operatorLabel": "Condition",
  "dialog.CreateMailingListDialog.valueLabel": "Value",
  "dialog.CreateMailingListDialog.valuePlaceholder": "e.g. true",
  "dialog.EditMailingListCriterionDialog.headline": "Edit criterion",

  "dialog.CreateEmailTemplateDialog.headline": "Create Email Template",
  "dialog.CreateEmailTemplateDialog.nameLabel": "Template Name",
  "dialog.CreateEmailTemplateDialog.namePlaceholder": "Monthly Newsletter Template",
  "dialog.CreateEmailTemplateDialog.reusableLabel": "Template Type",
  "dialog.CreateEmailTemplateDialog.reusableCheckboxLabel": "Reusable template",
  "dialog.CreateEmailTemplateDialog.reusableHelp": "Reusable templates can be used across multiple marketing emails. One-time templates are hidden from selection after their marketing email is sent.",

  "dialog.DeleteEmailTemplateDialog.headline": "Delete Email Template",
  "dialog.DeleteEmailTemplateDialog.confirmMessage": "Are you sure you want to delete the email template \"{name}\"?",

  "button.archive": "Archive",
  "button.launch": "Launch",
  "button.sendTestEmail": "Send Test Email",
  "button.sendTestEmail.disabledNoLayout": "Send Test Email (select a layout in the template first)",
  "button.launchMarketingEmail": "Launch",
  "button.archiveMarketingEmail": "Archive",
  "button.archiveMailingList": "Archive List",
  "button.restoreMailingList": "Restore List",
  "button.deleteEmailTemplate": "Delete Template",

  "errors.failedToCreateMarketingEmail": "Failed to create marketing email.",
  "errors.failedToRenameMarketingEmail": "Failed to rename marketing email.",
  "errors.failedToArchiveMarketingEmail": "Failed to archive marketing email.",
  "errors.failedToLaunchMarketingEmail": "Failed to launch marketing email.",
  "errors.failedToSendTestEmail": "Failed to send test email.",
  "errors.failedToAssignMailingList": "Failed to assign list.",
  "errors.failedToAssignTemplate": "Failed to assign template.",
  "errors.failedToAssignLayout": "Failed to assign layout.",
  "errors.failedToConfigureSender": "Failed to configure sender.",
  "errors.senderFieldsRequired": "Sender name and email are required.",
  "errors.failedToConfigureContent": "Failed to configure content.",
  "errors.failedToCreateMailingList": "Failed to create list.",
  "errors.failedToUpdateMailingListCriterion": "Failed to update criterion.",
  "errors.failedToResubscribeContact": "Failed to resubscribe contact.",
  "errors.failedToRenameMailingList": "Failed to rename list.",
  "errors.failedToUpdateMailingListDescription": "Failed to update list description.",
  "errors.failedToArchiveMailingList": "Failed to archive list.",
  "errors.failedToRestoreMailingList": "Failed to restore list.",
  "errors.failedToCreateEmailTemplate": "Failed to create email template.",
  "errors.failedToRenameEmailTemplate": "Failed to rename email template.",
  "errors.failedToUpdateEmailTemplateContent": "Failed to update email template content.",
  "errors.failedToDeleteEmailTemplate": "Failed to delete email template.",
  "validation.field.invalidEmail": "Invalid email address",

  "tab.marketing": "Marketing",
  "contact.marketing.lists": "Lists",
  "contact.marketing.noLists": "This contact is not in any list",
  "contact.marketing.header.listName": "List name",
  "contact.marketing.header.subscribedAt": "Subscribed since",
  "contact.marketing.header.unsubscribedAt": "Unsubscribed at",
  "contact.marketing.header.status": "Status",
  "button.addToList": "Add to list",
  "button.removeFromList": "Remove from list",
  "button.resubscribe": "Resubscribe",
  "dialog.SubscribeContactToListDialog.headline": "Add to list",
  "dialog.SubscribeContactToListDialog.listLabel": "List",
  "dialog.SubscribeContactToListDialog.listPlaceholder": "Search for a list",
  "dialog.RemoveContactFromListDialog.headline": "Remove from list",
  "dialog.RemoveContactFromListDialog.message": "Do you want to remove the contact from the list \"{listName}\"?",
  "errors.failedToSubscribeToList": "Failed to add to list.",
  "errors.failedToRemoveFromList": "Failed to remove from list.",
  "button.addContactToList": "Add contact",
  "dialog.AddContactToMailingListDialog.headline": "Add contact to list",
  "dialog.AddContactToMailingListDialog.contactLabel": "Contact",
  "dialog.AddContactToMailingListDialog.contactPlaceholder": "Search for a contact",
  "loading": "Loading...",

  "marketingEmail.delivery.statistics": "Delivery Statistics",
  "marketingEmail.delivery.list": "Deliveries",
  "marketingEmail.delivery.noDeliveries": "No deliveries yet",

  "delivery.status.queued": "Queued",
  "delivery.status.sent": "Sent",
  "delivery.status.delivered": "Delivered",
  "delivery.status.bounced": "Bounced",
  "delivery.status.failed": "Failed",

  "delivery.stat.total": "Total",
  "delivery.stat.queued": "Queued",
  "delivery.stat.sent": "Sent",
  "delivery.stat.delivered": "Delivered",
  "delivery.stat.bounced": "Bounced",
  "delivery.stat.failed": "Failed",

  "delivery.column.status": "Status",
  "delivery.column.recipient": "Recipient",
  "delivery.column.contact": "Contact",
  "delivery.column.sentAt": "Sent at",
  "delivery.column.deliveredAt": "Delivered at",
  "delivery.column.details": "Details",

  "marketingEmail.unsubscribes.title": "Unsubscribes",
  "marketingEmail.unsubscribes.noUnsubscribes": "No Unsubscribes",
  "marketingEmail.unsubscribes.noUnsubscribesDescription": "No contacts have unsubscribed from the mailing list through this marketing email yet.",
  "marketingEmail.unsubscribes.column.contact": "Contact",
  "marketingEmail.unsubscribes.column.unsubscribedAt": "Unsubscribed at",
  "marketingEmail.unsubscribes.column.reason": "Reason",

  "marketingEmail.preview.subject": "Subject",
  "marketingEmail.preview.noSubject": "No subject",

  "list.marketingEmail.header.template": "Template",

  "emailTemplate.field.primaryLanguage": "Primary Language",
  "emailTemplate.field.subject": "Subject",
  "emailTemplate.field.preheader": "Preheader",
  "emailTemplate.field.language": "Language",
  "emailTemplate.section.variants": "Language Variants",
  "emailTemplate.primaryBadge": "Primary",
  "emailTemplate.noSubject": "No subject",
  "emailTemplate.placeholder.subject": "Enter the email subject...",
  "emailTemplate.placeholder.preheader": "Preview text shown in email clients...",
  "emailTemplate.subtitle": "Created {createdAt} · {usageCount, plural, =0 {Not used} =1 {1 marketing email} other {# marketing emails}}",
  "emailTemplate.badge.draft": "Draft",
  "emailTemplate.badge.notUsed": "Not used",
  "emailTemplate.badge.usedInMarketingEmails": "{count, plural, =1 {1 marketing email} other {# marketing emails}}",

  "button.addLanguage": "Add Language",
  "button.setAsPrimary": "Set as Primary",
  "button.removeLanguage": "Remove Language",
  "button.close": "Close",

  "dialog.AddEmailTemplateVariantDialog.headline": "Add Language Variant",
  "dialog.AddEmailTemplateVariantDialog.description": "Add a new language variant to this email template.",
  "dialog.AddEmailTemplateVariantDialog.allLanguagesUsed": "All available languages already have variants.",

  "errors.failedToAddEmailTemplateVariant": "Failed to add language variant.",
  "errors.failedToUpdateEmailTemplateVariant": "Failed to update language variant.",
  "errors.failedToRemoveVariant": "Failed to remove language variant.",
  "errors.failedToSetPrimaryLanguage": "Failed to set primary language.",
  "errors.cannotRemoveLastVariant": "Cannot remove the last language variant.",
  "errors.failedToAssignLayoutToTemplate": "Failed to assign layout to template.",

  "emailTemplate.section.layout": "Layout",
  "emailTemplate.field.emailLayout": "Email Layout",
  "emailTemplate.preview.withLayout": "Preview",
  "emailLayout.badge.default": "Default",

  "tab.marketing.layouts": "Layouts",
  "navigation.emailLayouts": "Email Layouts",
  "breadcrumb.layouts": "Layouts",

  "view.emailLayouts.headline": "Email Layouts",
  "view.emailLayouts.createLayout": "Create Layout",
  "view.emailLayouts.noEmailLayouts": "No email layouts found",

  "view.emailLayout.notFound": "Email layout not found",
  "view.emailLayout.defaultLayout": "Default Layout",
  "view.emailLayout.htmlContent": "HTML Content",
  "view.emailLayout.htmlContentDescription": "The layout HTML wraps around the email content. Use {{content}} as a placeholder for the template content.",
  "view.emailLayout.availableVariables": "Available Variables:",
  "view.emailLayout.variable.content": "Template content is inserted here (required)",
  "view.emailLayout.variable.footerNote": "Footer content is inserted here (subscription preferences and legal notices)",
  "view.emailLayout.textContent": "Plain Text Layout",
  "view.emailLayout.textContentDescription": "The plain text layout wraps around the email content for plain text email versions. Use {{content}} as a placeholder for the template content.",
  "emailTemplate.layoutPreviewHint": "The gray areas show the layout text that will wrap your content.",

  "emailTemplate.section.images": "Images",
  "emailTemplate.images.upload": "Upload image",
  "emailTemplate.images.dragAndDrop": "or drag and drop",
  "emailTemplate.images.supportedFormats": "JPEG, PNG or GIF up to 10 MB",
  "emailTemplate.images.uploading": "Uploading...",
  "emailTemplate.images.uploadError": "Failed to upload image",
  "emailTemplate.images.readError": "Failed to read file",
  "emailTemplate.images.deleteError": "Failed to delete image",
  "emailTemplate.images.copyUrl": "Copy URL",
  "emailTemplate.images.copied": "Copied!",
  "emailTemplate.images.noImages": "No images uploaded",

  "list.emailLayout.header.name": "Name",
  "list.emailLayout.header.isDefault": "Default",
  "list.emailLayout.header.createdAt": "Created",
  "list.emailLayout.header.updatedAt": "Updated",
  "list.emailLayout.default": "Default",
  "list.emailLayout.action.show": "Show layout",

  "dialog.CreateEmailLayoutDialog.headline": "Create Email Layout",
  "dialog.CreateEmailLayoutDialog.nameLabel": "Layout Name",
  "dialog.CreateEmailLayoutDialog.namePlaceholder": "Flownative Standard",

  "dialog.RenameEmailLayoutDialog.headline": "Rename Email Layout",
  "dialog.RenameEmailLayoutDialog.nameLabel": "New Name",

  "dialog.SetEmailLayoutAsDefaultDialog.headline": "Set as Default",
  "dialog.SetEmailLayoutAsDefaultDialog.confirmMessage": "Do you want to set \"{name}\" as the default layout? The current default layout will no longer be used as default.",

  "dialog.DeleteEmailLayoutDialog.headline": "Delete Email Layout",
  "dialog.DeleteEmailLayoutDialog.confirmMessage": "Are you sure you want to delete the email layout \"{name}\"?",

  "action.rename": "Rename",
  "action.setAsDefault": "Set as Default",
  "action.delete": "Delete",
  "action.save": "Save",
  "action.editTitle": "Edit title",
  "action.copyIdentifier": "Click to copy identifier",

  "errors.failedToCreateEmailLayout": "Failed to create email layout.",
  "errors.failedToRenameEmailLayout": "Failed to rename email layout.",
  "errors.failedToSetEmailLayoutAsDefault": "Failed to set default layout.",
  "errors.failedToDeleteEmailLayout": "Failed to delete email layout.",
  "errors.failedToUpdateEmailLayoutContent": "Failed to update layout content.",

  "emailBlock.type.heading": "Heading",
  "emailBlock.type.paragraph": "Paragraph",
  "emailBlock.palette.title": "Add Block",
  "emailBlock.palette.hint": "Click to add a block",
  "emailBlock.empty": "Click a block type on the left to add content",
  "emailBlock.action.moveUp": "Move up",
  "emailBlock.action.moveDown": "Move down",
  "emailBlock.action.delete": "Delete block",
  "emailBlock.placeholder.heading": "Enter heading text...",
  "emailBlock.placeholder.paragraph": "Enter paragraph text...",
  "emailBlock.editor.empty": "Select a block to edit",
  "emailBlock.type.imageFullWidth": "Image",
  "emailBlock.type.imageFullWidthWithOverlay": "Image with Overlay",
  "emailBlock.image.selectImage": "Image",
  "emailBlock.image.uploadImage": "Upload image",
  "emailBlock.image.replaceImage": "Replace image",
  "emailBlock.image.altText": "Alt text",
  "emailBlock.image.altTextPlaceholder": "Description of the image...",
  "emailBlock.imageOverlay.headline": "Headline",
  "emailBlock.imageOverlay.headlinePlaceholder": "Enter headline...",
  "emailBlock.imageOverlay.subHeadline": "Sub-headline",
  "emailBlock.imageOverlay.subHeadlinePlaceholder": "Enter sub-headline...",
  "tab.analysis.forecast": "Forecast",
  "view.analysisForecast.area.accounts": "Bank statements",
  "view.analysisForecastAccounts.headline": "Bank accounts",
  "view.analysisForecastAccounts.empty": "No bank account yet. Add one under <link>Configuration → Finance</link>, then you can upload its statements here.",
  "view.analysisForecastAccounts.col.name": "Account",
  "view.analysisForecastAccounts.col.currentBalance": "Balance",
  "view.analysisForecastAccounts.col.coveredUntil": "Statement until",
  "view.analysisForecastAccounts.col.lastUpload": "Last upload",
  "view.analysisForecastAccounts.lastUpload.details": "{count, plural, one {# booking} other {# bookings}} from {start} to {end}, by {user}",
  "view.analysisForecastAccounts.noUpload": "No statement uploaded yet",
  "view.analysisForecastAccounts.action.upload": "Upload bank statement",
  "view.configurationBankAccounts.headline": "Bank accounts",
  "view.configurationBankAccounts.createButton": "Add bank account",
  "view.configurationBankAccounts.empty": "No bank accounts yet. Add an account with its balance on a given day, then you can upload its statements in the forecast.",
  "view.configurationBankAccounts.col.name": "Account",
  "view.configurationBankAccounts.col.anchor": "Known balance",
  "view.configurationBankAccounts.anchor": "{amount} on {date}",
  "view.configurationBankAccounts.action.edit": "Edit name and known balance",
  "errors.failedToCreateBankAccount": "Could not create the bank account.",
  "errors.failedToRenameBankAccount": "Could not rename the bank account.",
  "errors.failedToSetBankAccountAnchor": "Could not change the known balance of the bank account.",
  "validation.field.invalidAmount": "This is not an amount, use a format like 1.234,56",
  "dialog.EditBankAccountDialog.createHeadline": "Add bank account",
  "dialog.EditBankAccountDialog.editHeadline": "Edit bank account",
  "dialog.EditBankAccountDialog.nameLabel": "Name",
  "dialog.EditBankAccountDialog.anchorDateLabel": "As of",
  "dialog.EditBankAccountDialog.anchorBalanceLabel": "Known balance at the end of that day (EUR)",
  "dialog.EditBankAccountDialog.anchorDescription": "A balance you know for certain, e.g. from the bank statement or the BWA. Cabana calculates forwards and backwards from here using the uploaded bookings. Changing it applies to all days at once.",
  "dialog.UploadBankStatementDialog.headline": "Upload bank statement for {name}",
  "dialog.UploadBankStatementDialog.description": "Choose the CSV export of the bank. The file is read once and then discarded. Only the daily totals are kept, and they replace the days the file covers.",
  "dialog.UploadBankStatementDialog.coveredUntil": "Statement until",
  "dialog.UploadBankStatementDialog.coveredUntil.hint": "The last day the statement covers, usually the day of the export. Leave empty for the day before today. Days without bookings up to this day count as having none.",
  "dialog.UploadBankStatementDialog.submit": "Upload",
  "dialog.UploadBankStatementDialog.unreadable": "The file could not be read.",
  "dialog.UploadBankStatementDialog.result.period": "Period",
  "dialog.UploadBankStatementDialog.result.coveredUntil": "Statement until",
  "dialog.UploadBankStatementDialog.result.bookingCount": "Bookings",
  "dialog.UploadBankStatementDialog.result.balance": "Computed balance on {date}",
  "dialog.UploadBankStatementDialog.result.otherShare": "Share of \"Other\" in outgoing amounts",
  "dialog.UploadBankStatementDialog.result.adjustRules": "Adjust rules",
  "view.configurationBankTransactionRules.headline": "Rules for bank bookings",
  "view.configurationBankTransactionRules.addButton": "Add rule",
  "view.configurationBankTransactionRules.description": "Rules assign the bookings of an uploaded statement to a group. They are tried from top to bottom and the first matching rule wins. Without a matching rule, payments to known suppliers count as suppliers, other incoming bookings as customer payments and other outgoing ones as other. Changed rules apply from the next upload on. To apply them to bookings already uploaded, upload the file of that period again.",
  "view.configurationBankTransactionRules.empty": "No rules yet.",
  "view.configurationBankTransactionRules.col.condition": "If",
  "view.configurationBankTransactionRules.col.direction": "Bookings",
  "view.configurationBankTransactionRules.col.group": "Group",
  "view.configurationBankTransactionRules.condition": "{field} contains <b>{text}</b>",
  "view.configurationBankTransactionRules.action.moveUp": "Move up",
  "view.configurationBankTransactionRules.action.moveDown": "Move down",
  "view.configurationBankTransactionRules.action.edit": "Edit rule",
  "view.configurationBankTransactionRules.action.delete": "Remove rule",
  "bankTransactionRuleField.COUNTERPARTY_NAME": "Counterparty name",
  "bankTransactionRuleField.PURPOSE": "Purpose",
  "bankTransactionDirection.BOTH": "Incoming and outgoing",
  "bankTransactionDirection.IN": "Incoming only",
  "bankTransactionDirection.OUT": "Outgoing only",
  "bankTransactionGroup.CUSTOMER_PAYMENTS": "Customer payments",
  "bankTransactionGroup.SUPPLIERS": "Suppliers",
  "bankTransactionGroup.SALARIES": "Salaries and social security",
  "bankTransactionGroup.TAX_OFFICE": "Tax office",
  "bankTransactionGroup.FINANCING": "Financing",
  "bankTransactionGroup.TRANSFER": "Transfer between own accounts",
  "bankTransactionGroup.OTHER": "Other",
  "forecastCategory.REVENUE": "Revenue",
  "forecastCategory.OTHER_OPERATING_INCOME": "Other operating income",
  "forecastCategory.SUPPLIERS": "Suppliers",
  "forecastCategory.PERSONNEL": "Personnel",
  "forecastCategory.DEPRECIATION": "Depreciation",
  "forecastCategory.INCOME_TAXES": "Taxes on income and profit",
  "forecastCategory.FINANCING": "Financing",
  "forecastCategory.OTHER": "Other",
  "errors.failedToAddBankTransactionRule": "Could not add the rule.",
  "errors.failedToChangeBankTransactionRule": "Could not change the rule.",
  "errors.failedToRemoveBankTransactionRule": "Could not remove the rule.",
  "errors.failedToMoveBankTransactionRule": "Could not move the rule.",
  "dialog.EditBankTransactionRuleDialog.addHeadline": "Add rule",
  "dialog.EditBankTransactionRuleDialog.editHeadline": "Edit rule",
  "dialog.EditBankTransactionRuleDialog.fieldLabel": "Look at",
  "dialog.EditBankTransactionRuleDialog.containedTextLabel": "Contains",
  "dialog.EditBankTransactionRuleDialog.directionLabel": "Applies to",
  "dialog.EditBankTransactionRuleDialog.groupLabel": "Group",
  "dialog.EditBankTransactionRuleDialog.description": "Upper and lower case do not matter. A new rule is added behind the existing ones. Move it up to make it win over other rules. It applies from the next upload on.",
  "dialog.DeleteBankTransactionRuleDialog.headline": "Remove rule",
  "dialog.DeleteBankTransactionRuleDialog.confirmMessage": "Do you really want to remove the rule for \"{text}\"? Bookings already uploaded keep their group until their period is uploaded again.",
  "view.analysisForecast.area.bwa": "BWA",
  "validation.field.invalidMonth": "Use the format YYYY-MM, e.g. 2026-08",
  "errors.failedToRecordBwaMonth": "The BWA values could not be saved",
  "errors.failedToRemoveBwaMonth": "The BWA values could not be removed",
  "view.analysisForecastBwa.headline": "BWA values per month",
  "view.analysisForecastBwa.recordButton": "Record month",
  "view.analysisForecastBwa.description": "Values from the BWA, entered by hand. All amounts are net. A month with values is shown as “with BWA” in the result table. The closing balances are compared with the balances computed from the uploaded statements; a difference is highlighted.",
  "view.analysisForecastBwa.empty": "No BWA values yet.",
  "view.analysisForecastBwa.missing": "BWA values are still missing for {months}. Until then these months count as “without BWA”.",
  "view.analysisForecastBwa.col.month": "Month",
  "view.analysisForecastBwa.col.revenue": "Revenue",
  "view.analysisForecastBwa.col.otherOperatingIncome": "Other operating income",
  "view.analysisForecastBwa.col.personnelCosts": "Personnel",
  "view.analysisForecastBwa.col.hostingAndLicences": "Hosting, licences",
  "view.analysisForecastBwa.col.otherCosts": "Other costs",
  "view.analysisForecastBwa.col.depreciation": "Depreciation",
  "view.analysisForecastBwa.col.incomeTaxes": "Income taxes",
  "view.analysisForecastBwa.col.closingBalances": "Balance (BWA)",
  "view.analysisForecastBwa.col.differences": "Difference to uploads",
  "view.analysisForecastBwa.recordedBy": "Recorded by {user} on {date}",
  "view.analysisForecastBwa.changedBy": "Corrected by {user} on {date}",
  "view.analysisForecastBwa.action.edit": "Correct values",
  "view.analysisForecastBwa.action.delete": "Remove values",
  "dialog.EditBwaMonthDialog.recordHeadline": "Record BWA month",
  "dialog.EditBwaMonthDialog.editHeadline": "Correct BWA month",
  "dialog.EditBwaMonthDialog.monthLabel": "Month (YYYY-MM)",
  "dialog.EditBwaMonthDialog.revenueLabel": "Revenue",
  "dialog.EditBwaMonthDialog.otherOperatingIncomeLabel": "Other operating income",
  "dialog.EditBwaMonthDialog.personnelCostsLabel": "Personnel costs",
  "dialog.EditBwaMonthDialog.hostingAndLicencesLabel": "Hosting, software and licences",
  "dialog.EditBwaMonthDialog.otherCostsLabel": "Other costs",
  "dialog.EditBwaMonthDialog.otherCostsHint": "Total costs minus the other cost fields",
  "dialog.EditBwaMonthDialog.depreciationLabel": "Depreciation",
  "dialog.EditBwaMonthDialog.incomeTaxesLabel": "Income taxes",
  "dialog.EditBwaMonthDialog.closingBalanceLabel": "Balance {account} at month end",
  "dialog.EditBwaMonthDialog.description": "All amounts net in EUR, costs as positive numbers. Saving a month that has values already corrects them.",
  "dialog.DeleteBwaMonthDialog.headline": "Remove BWA values",
  "dialog.DeleteBwaMonthDialog.confirmMessage": "Do you really want to remove the BWA values of {month}? The month is not closed any more.",
  "view.analysisForecast.area.plannedItems": "Planned items",
  "validation.field.endMonthBeforeStartMonth": "The end month cannot be before the start month",
  "validation.field.invalidDayOfMonth": "Use a day from 1 to 31",
  "errors.failedToAddPlannedItem": "The planned item could not be added",
  "errors.failedToChangePlannedItem": "The planned item could not be changed",
  "errors.failedToRemovePlannedItem": "The planned item could not be removed",
  "errors.failedToSwitchPlannedItem": "The planned item could not be switched",
  "errors.failedToSetSubscriptionAmountOverride": "The amount could not be saved",
  "errors.failedToRemoveSubscriptionAmountOverride": "The amount could not be removed",
  "errors.failedToSetSupplierAmountOverride": "The amount could not be saved",
  "errors.failedToRemoveSupplierAmountOverride": "The amount could not be removed",
  "plannedItemRhythm.MONTHLY": "Monthly",
  "plannedItemRhythm.QUARTERLY": "Quarterly",
  "plannedItemRhythm.YEARLY": "Yearly",
  "plannedItemRhythm.ONE_TIME": "One time",
  "plannedItemEffect.RESULT_AND_LIQUIDITY": "Result and liquidity",
  "plannedItemEffect.LIQUIDITY_ONLY": "Liquidity only",
  "plannedItemEffect.RESULT_ONLY": "Result only",
  "view.analysisForecastPlannedItems.headline": "Planned items",
  "view.analysisForecastPlannedItems.addButton": "Add planned item",
  "view.analysisForecastPlannedItems.description": "Payments Cabana does not know from its own data, like salaries, advance payments of taxes or insurances. Amounts are net, money going out is negative. A switched off item is kept, but the forecast ignores it.",
  "view.analysisForecastPlannedItems.empty": "No planned items yet.",
  "view.analysisForecastPlannedItems.col.enabled": "On",
  "view.analysisForecastPlannedItems.col.name": "Name",
  "view.analysisForecastPlannedItems.col.rhythm": "Rhythm",
  "view.analysisForecastPlannedItems.col.nextDueDate": "Next due",
  "view.analysisForecastPlannedItems.col.netAmount": "Net amount",
  "view.analysisForecastPlannedItems.dayOfMonth": "on the {day}.",
  "view.analysisForecastPlannedItems.liquidityGroup": "Liquidity: {group}",
  "view.analysisForecastPlannedItems.period": "{start} to {end}",
  "view.analysisForecastPlannedItems.from": "from {start}",
  "view.analysisForecastPlannedItems.in": "in {start}",
  "view.analysisForecastPlannedItems.plusVat": "+ {rate} % VAT",
  "view.analysisForecastPlannedItems.action.enable": "Switch on",
  "view.analysisForecastPlannedItems.action.disable": "Switch off",
  "view.analysisForecastPlannedItems.action.edit": "Edit planned item",
  "view.analysisForecastPlannedItems.action.delete": "Delete planned item",
  "view.analysisForecastPlannedItems.overrides.headline": "Own amounts for subscriptions",
  "view.analysisForecastPlannedItems.overrides.addButton": "Set amount for a subscription",
  "view.analysisForecastPlannedItems.overrides.description": "The income forecast uses the monthly amount from the last settlement of a subscription. Set your own amount if that settlement contained a back charge, for example.",
  "view.analysisForecastPlannedItems.overrides.empty": "No own amounts yet.",
  "view.analysisForecastPlannedItems.overrides.col.subscription": "Subscription",
  "view.analysisForecastPlannedItems.overrides.col.monthlyNetAmount": "Net amount per month",
  "view.analysisForecastPlannedItems.overrides.col.note": "Note",
  "view.analysisForecastPlannedItems.overrides.col.setBy": "Set by",
  "view.analysisForecastPlannedItems.overrides.setBy": "{user} on {date}",
  "view.analysisForecastPlannedItems.overrides.action.edit": "Change amount",
  "view.analysisForecastPlannedItems.overrides.action.remove": "Remove amount",
  "view.analysisForecastPlannedItems.supplierOverrides.headline": "Own amounts for suppliers",
  "view.analysisForecastPlannedItems.supplierOverrides.addButton": "Set amount for a supplier",
  "view.analysisForecastPlannedItems.supplierOverrides.description": "The expense forecast continues a supplier with the amounts of its last invoices. Set an own amount if the last invoice contains a one-off purchase, for example.",
  "view.analysisForecastPlannedItems.supplierOverrides.col.supplier": "Supplier",
  "view.analysisForecastPlannedItems.supplierOverrides.col.netAmount": "Net amount per invoice",
  "dialog.EditPlannedItemDialog.addHeadline": "Add planned item",
  "dialog.EditPlannedItemDialog.editHeadline": "Edit planned item",
  "dialog.EditPlannedItemDialog.nameLabel": "Name",
  "dialog.EditPlannedItemDialog.categoryLabel": "Category",
  "dialog.EditPlannedItemDialog.categoryHint": "Personnel covers salaries, wage tax and social contributions. Financing (such as a loan) changes the liquidity only. In months with a BWA, personnel, depreciation, taxes on income and profit and other operating income come from the BWA, planned items of these categories count for the liquidity only there.",
  "dialog.EditPlannedItemDialog.netAmountLabel": "Net amount",
  "dialog.EditPlannedItemDialog.netAmountHint": "Negative for money going out, e.g. -700,00",
  "dialog.EditPlannedItemDialog.vatRateLabel": "VAT rate",
  "dialog.EditPlannedItemDialog.rhythmLabel": "Rhythm",
  "dialog.EditPlannedItemDialog.startMonthLabel": "First month (YYYY-MM)",
  "dialog.EditPlannedItemDialog.endMonthLabel": "Last month (YYYY-MM), optional",
  "dialog.EditPlannedItemDialog.dayOfMonthLabel": "Day of the month",
  "dialog.EditPlannedItemDialog.dayOfMonthHint": "In a month that is shorter, the last day applies.",
  "dialog.EditPlannedItemDialog.effectLabel": "Effect",
  "dialog.EditPlannedItemDialog.liquidityGroupLabel": "Payment to (liquidity)",
  "dialog.EditPlannedItemDialog.liquidityGroupSameAsCategory": "As the category",
  "dialog.EditPlannedItemDialog.liquidityGroupHint": "The row of the liquidity the payment is shown in. Wage tax, for example, is personnel costs in the result but is paid to the tax office.",
  "dialog.DeletePlannedItemDialog.headline": "Delete planned item",
  "dialog.DeletePlannedItemDialog.confirmMessage": "Do you really want to delete the planned item \"{name}\"? To keep it, switch it off instead.",
  "dialog.EditSubscriptionAmountOverrideDialog.addHeadline": "Set amount for a subscription",
  "dialog.EditSubscriptionAmountOverrideDialog.editHeadline": "Change amount of a subscription",
  "dialog.EditSubscriptionAmountOverrideDialog.subscriptionLabel": "Subscription",
  "dialog.EditSubscriptionAmountOverrideDialog.monthlyNetAmountLabel": "Net amount per month",
  "dialog.EditSubscriptionAmountOverrideDialog.noteLabel": "Note",
  "dialog.EditSubscriptionAmountOverrideDialog.description": "Search for the customer or the label of the subscription. The income forecast uses this amount per month instead of the amount from the settlements.",
  "dialog.RemoveSubscriptionAmountOverrideDialog.headline": "Remove amount",
  "dialog.RemoveSubscriptionAmountOverrideDialog.confirmMessage": "Do you really want to remove the own amount for {subscription}? The income forecast uses the amount from the settlements again.",
  "dialog.EditSupplierAmountOverrideDialog.addHeadline": "Set amount for a supplier",
  "dialog.EditSupplierAmountOverrideDialog.editHeadline": "Change amount of a supplier",
  "dialog.EditSupplierAmountOverrideDialog.supplierLabel": "Supplier",
  "dialog.EditSupplierAmountOverrideDialog.netAmountLabel": "Net amount per invoice",
  "dialog.EditSupplierAmountOverrideDialog.noteLabel": "Note",
  "dialog.EditSupplierAmountOverrideDialog.description": "You can pick suppliers who bill regularly. The expense forecast then continues the supplier with one invoice per billing period over this amount, instead of the amounts of its last invoices. 0 takes it out of the forecast.",
  "dialog.RemoveSupplierAmountOverrideDialog.headline": "Remove amount",
  "dialog.RemoveSupplierAmountOverrideDialog.confirmMessage": "Do you really want to remove the own amount for {supplier}? The expense forecast continues its last invoices again.",
  "view.analysisForecast.area.overview": "Overview",
  "view.analysisForecastOverview.loading": "Computing the forecast …",
  "view.analysisForecastOverview.currentBalance": "Balance (both accounts)",
  "view.analysisForecastOverview.asOf": "As of {date}, forecast after that",
  "view.analysisForecastOverview.minimumBalance": "Minimum balance",
  "view.analysisForecastOverview.minimumBalance.notSet": "not set",
  "view.analysisForecastOverview.minimumBalance.edit": "Change the minimum balance",
  "view.analysisForecastOverview.minimumBalance.save": "Save",
  "view.analysisForecastOverview.minimumBalance.cancel": "Cancel",
  "view.analysisForecastOverview.minimumBalance.description": "For both accounts together",
  "view.analysisForecastOverview.shortfall": "On {date} the balance falls below the minimum balance.",
  "view.analysisForecastOverview.noShortfall": "The balance does not fall below the minimum balance in the forecast.",
  "view.analysisForecastOverview.chart.headline": "Balance at the end of the month",
  "view.analysisForecastOverview.chart.total": "Both accounts",
  "view.analysisForecastOverview.chart.legend": "Solid: balance according to the bank. Dashed: forecast. The lines of the individual accounts are shown only for months the bank statements cover completely.",
  "view.analysisForecastOverview.status.CLOSED": "with BWA",
  "view.analysisForecastOverview.status.PROVISIONAL": "without BWA",
  "view.analysisForecastOverview.status.BANK": "Bank",
  "view.analysisForecastOverview.status.BANK_AND_FORECAST": "Bank + forecast",
  "view.analysisForecastOverview.status.FORECAST": "Forecast",
  "view.analysisForecastOverview.status.CLOSED.title": "BWA values are recorded for this month: personnel, depreciation and taxes come from the BWA.",
  "view.analysisForecastOverview.status.PROVISIONAL.title": "Past month without BWA values yet: personnel, depreciation and taxes are missing or estimated.",
  "view.analysisForecastOverview.status.FORECAST.title": "Current or future month: existing invoices plus expected amounts and planned items.",
  "view.analysisForecastOverview.result.statusLegend": "with BWA: BWA values are recorded. without BWA: past month whose BWA is still missing (italic). Forecast: current or future month (italic).",
  "view.analysisForecastOverview.result.headline": "Result",
  "view.analysisForecastOverview.result.description": "Net, by month of service. Revenue and suppliers always come from Cabana. In months with BWA, personnel, depreciation, taxes on income and profit and other operating income come from the BWA.",
  "view.analysisForecastOverview.result.beforeIncomeTaxes": "Result before income taxes",
  "view.analysisForecastOverview.result.result": "Result",
  "view.analysisForecastOverview.result.bwa.REVENUE": "Revenue per BWA",
  "view.analysisForecastOverview.result.bwa.SUPPLIERS": "Suppliers per BWA",
  "view.analysisForecastOverview.result.bwa.description": "The rows \"per BWA\" show revenue and costs (hosting, licences and other costs) as the tax advisor books them: by invoice date. So they mostly belong to the month before. They are for comparison only and are no part of the result.",
  "view.analysisForecastOverview.liquidity.headline": "Liquidity",
  "view.analysisForecastOverview.liquidity.description": "Gross, by day of payment. Up to the last booking day the bookings of the bank count, after it the forecast. The forecast expects overdue receivables after the usual payment time of the customer, but at least seven days after the last booking day.",
  "view.analysisForecastOverview.liquidity.opening": "Opening balance",
  "view.analysisForecastOverview.liquidity.totalInflows": "Total inflows",
  "view.analysisForecastOverview.liquidity.totalOutflows": "Total outflows",
  "view.analysisForecastOverview.liquidity.overdueReceivables": "overdue receivables",
  "view.analysisForecastOverview.liquidity.transfers": "Transfers (net)",
  "view.analysisForecastOverview.liquidity.closing": "Closing balance",
  "view.analysisForecastOverview.liquidity.lowest": "Lowest balance",
  "view.analysisForecastOverview.legend.liquidityForecast": "Months with a forecast, wholly or partly",
  "view.analysisForecastOverview.legend.drillDown": "Click an amount to see what it consists of.",
  "view.analysisForecastOverview.parts.headline": "{table}: {line}, {month}",
  "view.analysisForecastOverview.parts.result": "Result",
  "view.analysisForecastOverview.parts.liquidity": "Liquidity",
  "view.analysisForecastOverview.parts.bwa": "BWA",
  "view.analysisForecastOverview.parts.close": "Close",
  "view.analysisForecastOverview.parts.expectedPayment": "Expected payment",
  "view.analysisForecastOverview.parts.paymentDay": "Payment day",
  "view.analysisForecastOverview.parts.net": "Net",
  "view.analysisForecastOverview.parts.vat": "VAT",
  "view.analysisForecastOverview.parts.gross": "Gross",
  "view.analysisForecastOverview.parts.sum": "Total",
  "view.analysisForecastOverview.parts.invoicesLabel": "{count, plural, one {# invoice} other {# invoices}}",
  "view.analysisForecastOverview.parts.postponed": "moved to the next month",
  "view.analysisForecastOverview.parts.expected": "expected",
  "view.analysisForecastOverview.parts.estimate.INVOICED_USAGE": "usage per {source} invoice",
  "view.analysisForecastOverview.parts.estimate.ESTIMATE": "{source} estimate as of {date}",
  "view.analysisForecastOverview.parts.estimate.CONTINUED_ESTIMATE": "{source} estimate continued, as of {date}",
  "view.analysisForecastOverview.parts.estimateSource.HETZNER": "Hetzner",
  "view.analysisForecastOverview.parts.bankBookingsLabel": "Bank bookings up to {date}",
  "view.analysisForecastOverview.parts.kind.BWA": "BWA",
  "view.analysisForecastOverview.parts.kind.INVOICES": "Outgoing invoices by customer",
  "view.analysisForecastOverview.parts.kind.EXPENSE_SUPPLIER": "Incoming invoices by expense category and supplier",
  "view.analysisForecastOverview.parts.kind.BANK_BOOKINGS": "Bank",
  "view.analysisForecastOverview.parts.kind.SUBSCRIPTION": "Subscriptions",
  "view.analysisForecastOverview.parts.kind.OPEN_INVOICE": "Open invoices",
  "view.analysisForecastOverview.parts.kind.SUPPLIER": "Suppliers",
  "view.analysisForecastOverview.parts.kind.PLANNED_ITEM": "Planned items",
  "view.analysisForecastOverview.parts.kind.VAT_PAYMENT": "VAT payment",
  "view.analysisForecastOverview.accountsDiffer": "The bank statements cover until different days: {accounts}. The forecast starts after {date}.",
  "view.analysisForecastOverview.accountsDiffer.account": "{name} until {date}",
  "view.analysisForecastOverview.parts.vatPaymentLabel": "VAT {month}",
  "view.analysisForecastOverview.parts.vat.header": "VAT for {month}, due on {date}",
  "view.analysisForecastOverview.parts.vat.OUTGOING_INVOICES": "VAT of {count, plural, one {# outgoing invoice} other {# outgoing invoices}}",
  "view.analysisForecastOverview.parts.vat.INCOMING_INVOICES": "Input VAT of {count, plural, one {# incoming invoice} other {# incoming invoices}}",
  "view.analysisForecastOverview.doubtful.headline": "Doubtful receivables",
  "view.analysisForecastOverview.doubtful.description": "Overdue open invoices whose payment the forecast does not expect any more. They are not part of the forecast.",
  "view.analysisForecastOverview.doubtful.customer": "Customer",
  "view.analysisForecastOverview.doubtful.invoice": "Invoice",
  "view.analysisForecastOverview.doubtful.reason": "Reason",
  "view.analysisForecastOverview.doubtful.reason.LONG_OVERDUE": "more than 90 days overdue",
  "view.analysisForecastOverview.doubtful.reason.SLOW_PAYER": "slow payer",
  "view.analysisForecastOverview.doubtful.overdue": "Overdue",
  "view.analysisForecastOverview.doubtful.amount": "Gross",
  "view.analysisForecastOverview.doubtful.days": "{count, plural, one {# day} other {# days}}",
  "view.analysisForecastOverview.hint": "Forecast months are based on running subscriptions, recurring suppliers and planned items. You can switch planned items on and off under <link>Planned items</link>.",
  "view.analysisForecastOverview.noBankAccount": "Without a bank account the forecast has no balance to start from. Add one under <link>Configuration → Finance</link>.",
  "errors.failedToSetMinimumBalance": "Could not save the minimum balance."
}
